var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/init-masonry-registry.ts
import { MasonryDriverNodeRenderersRegistry } from "@leagueplatform/masonry";

// src/components/masonry-renderers/claim-card-renderer/claim-card-renderer.component.tsx
import * as React from "react";
import {
  useMasonryEngineActionEmitter
} from "@leagueplatform/masonry-engine";
import { InternalOrExternalLink as Link } from "@leagueplatform/web-common-components";
import {
  StackLayout,
  StatusBadge,
  Card,
  Box,
  useClickableCard,
  HeadingText,
  StackItem,
  focusOutlineOuter,
  TextAction,
  UtilityText,
  Icon
} from "@leagueplatform/genesis-core";
import {
  CLAIMS_MASONRY_STATUS_COLORS_MAP
} from "@leagueplatform/claims-common";
var NODE_TYPE_CLAIM_CARD = "claimCard";
var ClaimCardRenderer = ({
  amount,
  amountPrefix,
  eyebrow,
  heading,
  hideChevron = false,
  status,
  statusText,
  textLineOne,
  textLineTwo,
  headingLevel = "3",
  onClick
}) => {
  var _a, _b;
  const invokeAction = useMasonryEngineActionEmitter();
  const { clickAreaRef, onCardMouseDown, onCardMouseUp, primaryActionRef } = useClickableCard();
  const handleOnClick = React.useCallback(
    (event) => {
      if (onClick) {
        invokeAction(__spreadValues({ event }, onClick));
      }
    },
    [invokeAction, onClick]
  );
  let claimStatusColors;
  if (status) {
    claimStatusColors = CLAIMS_MASONRY_STATUS_COLORS_MAP[status];
  }
  const hasStatusColor = !!claimStatusColors;
  const hasTopBar = !!eyebrow || !!statusText;
  return /* @__PURE__ */ React.createElement(
    Card.Elevated,
    {
      backgroundColor: "secondary",
      imagePosition: "start",
      css: {
        "&&:has(.GDS-card-click-area)": {
          boxShadow: "$card"
        },
        "&:focus-within": __spreadValues({}, focusOutlineOuter)
      }
    },
    /* @__PURE__ */ React.createElement(
      Card.ClickArea,
      {
        ref: clickAreaRef,
        onCardMouseDown,
        onCardMouseUp,
        css: {
          display: "flex",
          border: "solid $onSurfaceBorderSubdued",
          borderWidth: "$thin"
        },
        imagePosition: "start"
      },
      claimStatusColors && /* @__PURE__ */ React.createElement(
        Box,
        {
          css: {
            width: "$half",
            backgroundColor: claimStatusColors.sidebarColor
          }
        }
      ),
      /* @__PURE__ */ React.createElement(
        Card.Section,
        {
          padding: "$oneAndHalf",
          css: {
            paddingInlineStart: hasStatusColor ? "$one" : void 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "$oneAndHalf"
          }
        },
        /* @__PURE__ */ React.createElement(
          StackLayout,
          {
            orientation: { "@initial": "horizontal", "@mobile": "vertical" },
            spacing: "$one",
            verticalAlignment: "center"
          },
          /* @__PURE__ */ React.createElement(
            StackItem,
            {
              css: { flex: 3, flexGrow: 0, "@mobile": { width: "100%" } }
            },
            /* @__PURE__ */ React.createElement(StackLayout, { spacing: "$threeQuarters" }, /* @__PURE__ */ React.createElement(StackLayout, { spacing: "$half", css: { width: "100%" } }, /* @__PURE__ */ React.createElement(
              Box,
              {
                css: {
                  width: "100%",
                  display: hasTopBar ? "flex" : "none",
                  gap: "$threeQuarters",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  flexWrap: "wrap"
                }
              },
              eyebrow && /* @__PURE__ */ React.createElement(UtilityText, { as: "p", css: { typography: "$caption" } }, eyebrow),
              statusText && /* @__PURE__ */ React.createElement(
                StatusBadge,
                {
                  label: statusText,
                  status: (_a = claimStatusColors == null ? void 0 : claimStatusColors.badgeColor) != null ? _a : "neutral",
                  showLight: false
                }
              )
            ), /* @__PURE__ */ React.createElement(
              UtilityText,
              {
                as: HeadingText,
                level: headingLevel,
                css: {
                  "@mobile": {
                    textOverflow: "ellipsis"
                  }
                }
              },
              /* @__PURE__ */ React.createElement(
                TextAction,
                {
                  as: Link,
                  css: { all: "inherit !important" },
                  href: (_b = onClick == null ? void 0 : onClick.payload) == null ? void 0 : _b.url,
                  onClick: handleOnClick,
                  ref: primaryActionRef
                },
                heading
              )
            ), /* @__PURE__ */ React.createElement(UtilityText, { as: "p", css: { typography: "$caption" } }, textLineOne), /* @__PURE__ */ React.createElement(UtilityText, { as: "p", css: { typography: "$caption" } }, textLineTwo)), /* @__PURE__ */ React.createElement(
              Box,
              {
                css: {
                  display: "flex",
                  alignItems: "baseline",
                  "@mobile": { marginTop: "$half" }
                }
              },
              /* @__PURE__ */ React.createElement(UtilityText, { as: "p", css: { typography: "$caption" } }, amountPrefix, amount && /* @__PURE__ */ React.createElement(
                HeadingText,
                {
                  as: "strong",
                  level: "display",
                  size: "lg",
                  css: { display: "inline" }
                },
                amount
              ))
            ))
          )
        ),
        !hideChevron && /* @__PURE__ */ React.createElement(Icon, { icon: "interfaceChevronForward", "aria-hidden": true })
      )
    )
  );
};

// src/init-masonry-registry.ts
var initMasonryRegistry = () => {
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "claims",
    NODE_TYPE_CLAIM_CARD,
    ClaimCardRenderer
  );
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import InstitutionalClaimIcon from "./assets/claim-icon-institutional.svg";
import OralClaimIcon from "./assets/claim-icon-oral.svg";
import ClaimsListEmpty from "./assets/claims-list-empty.svg";
var CLAIMS_UI_MODULE_ASSETS_MAP = {
  INSTITUTIONAL: InstitutionalClaimIcon,
  VISION: "interfaceVisible",
  PHARMACY: "descriptivePill",
  ORAL: OralClaimIcon,
  DEFAULT: "descriptiveInsurance",
  CLAIMS_LIST_EMPTY: ClaimsListEmpty
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(CLAIMS_UI_MODULE_ASSETS_MAP);
};

// src/components/claim-card/claim-card.component.tsx
import * as React3 from "react";
import {
  StackLayout as StackLayout3,
  StatusBadge as StatusBadge2,
  Card as Card2,
  Box as Box3,
  useClickableCard as useClickableCard2,
  HeadingText as HeadingText2,
  StackItem as StackItem3,
  focusOutlineOuter as focusOutlineOuter2,
  TextAction as TextAction2,
  useMediaQuery as useMediaQuery2,
  queryHelpers as queryHelpers2,
  UtilityText as UtilityText2
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import { SHORT_DATE_FORMAT } from "@leagueplatform/web-common";
import { LEAGUE_MODULE_NAMES, getModulePath } from "@leagueplatform/core";
import { CLAIMS_STATUS_COLORS_MAP } from "@leagueplatform/claims-common";
import { LinkLegacy as RouterLink } from "@leagueplatform/routing";

// src/hooks/use-claim-owed-amount-label.hook.ts
import { useFormatClaimsValue } from "@leagueplatform/claims-common";
import { useIntl } from "@leagueplatform/locales";
function useClaimOwedAmountLabel({
  owed,
  isPending
}) {
  const { formatMessage } = useIntl();
  const formatClaimValue = useFormatClaimsValue();
  const { label } = owed || {};
  if (label) {
    return label;
  }
  const hasMissingOwedAmount = owed === void 0;
  if (isPending) {
    return formatMessage({ id: "CLAIMS_STATUS_PENDING" });
  }
  if (hasMissingOwedAmount) {
    return formatMessage({ id: "CLAIMS_OWED_AMOUNT_MISSING_LABEL" });
  }
  return formatClaimValue(owed);
}

// src/hooks/use-status-filter-value-message-translation.ts
import { useIntl as useIntl2 } from "@leagueplatform/locales";
var useStatusFilterValueMessageTranslation = () => useIntl2().$tmap({
  approved: "CLAIMS_FILTER_VALUE_APPROVED",
  pending: "CLAIMS_FILTER_VALUE_PENDING",
  partially_paid: "CLAIMS_FILTER_VALUE_PARTIALLY_PAID",
  not_covered: "CLAIMS_FILTER_VALUE_NOT_COVERED",
  adjusted: "CLAIMS_FILTER_VALUE_ADJUSTED"
});

// src/components/claim-card/components/member-name-section.component.tsx
import * as React2 from "react";

// src/utils/get-claim-type-icon.util.ts
import { handleStaticAsset } from "@leagueplatform/asset-config";
var icons = {
  institutional: "INSTITUTIONAL" /* INSTITUTIONAL */,
  vision: "VISION" /* VISION */,
  pharmacy: "PHARMACY" /* PHARMACY */,
  oral: "ORAL" /* ORAL */
};
function hasIcon(claimType) {
  return claimType in icons;
}
function getClaimTypeIcon(claimType) {
  if (hasIcon(claimType)) {
    return handleStaticAsset(icons[claimType]);
  }
  return void 0;
}

// src/components/claim-card/components/member-name-section.component.tsx
import {
  Box as Box2,
  Icon as Icon2,
  ParagraphText,
  queryHelpers,
  StackItem as StackItem2,
  StackLayout as StackLayout2,
  styled,
  useMediaQuery
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
var ImageWrapper = styled(Box2, {
  borderRadius: "$circle",
  backgroundColor: "$surfaceBackgroundTertiary",
  minWidth: "$oneAndHalf",
  minHeight: "$oneAndHalf",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});
function MemberNameSection({
  patientName,
  identifier,
  claimType
}) {
  var _a;
  const { formatMessage } = useIntl3();
  const isAboveMobile = useMediaQuery(queryHelpers.up("mobileLandscape"));
  const icon = (_a = getClaimTypeIcon(claimType)) != null ? _a : handleStaticAsset2("DEFAULT" /* DEFAULT */);
  return /* @__PURE__ */ React2.createElement(StackItem2, { css: { flex: 1, flexGrow: 0, "@mobile": { width: "100%" } } }, /* @__PURE__ */ React2.createElement(
    StackLayout2,
    {
      spacing: { "@initial": "$one", "@mobile": "$half" },
      css: {
        justifyContent: "center"
      }
    },
    /* @__PURE__ */ React2.createElement(
      Box2,
      {
        css: {
          display: "flex",
          gap: "$half",
          alignItems: "center"
        }
      },
      isAboveMobile && /* @__PURE__ */ React2.createElement(ImageWrapper, null, /* @__PURE__ */ React2.createElement(
        Icon2,
        {
          icon: "descriptivePerson",
          size: "$threeQuarters",
          tint: "$onSurfaceIconPrimary"
        }
      )),
      /* @__PURE__ */ React2.createElement(ParagraphText, { css: { typography: "$caption" } }, formatMessage({ id: "CLAIM_PATIENT_NAME" }, { patientName }))
    ),
    /* @__PURE__ */ React2.createElement(
      Box2,
      {
        css: {
          display: "flex",
          gap: "$half",
          alignItems: "center"
        }
      },
      isAboveMobile && /* @__PURE__ */ React2.createElement(ImageWrapper, null, /* @__PURE__ */ React2.createElement(
        Icon2,
        {
          icon,
          size: "$threeQuarters",
          tint: "$onSurfaceIconPrimary"
        }
      )),
      /* @__PURE__ */ React2.createElement(ParagraphText, { css: { typography: "$caption" } }, `${formatMessage(
        {
          id: "CLAIMS_SERVICE_TYPE"
        },
        { type: claimType }
      )} #${identifier}`)
    )
  ));
}

// src/components/claim-card/claim-card.component.tsx
var CLAIMS_DATE_FORMAT = __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT), {
  timeZone: "UTC"
});
var defaultClaimsPath = getModulePath(LEAGUE_MODULE_NAMES.claims);
var ClaimCard = ({
  claimsPath = defaultClaimsPath,
  onClick,
  showColorBar = false,
  identifier,
  patientName,
  providerName,
  serviceDate,
  status,
  owed,
  claimType
}) => {
  const { formatMessage, formatDate } = useIntl4();
  const isAboveMobile = useMediaQuery2(queryHelpers2.up("mobileLandscape"));
  const { clickAreaRef, onCardMouseDown, onCardMouseUp, primaryActionRef } = useClickableCard2();
  const owedAmountLabel = useClaimOwedAmountLabel({
    owed,
    isPending: status === "pending"
  });
  const claimDetailsPath = `${claimsPath}/${identifier}`;
  const claimStatusColors = CLAIMS_STATUS_COLORS_MAP[status];
  const hasStatusColor = claimStatusColors && showColorBar;
  const getStatusFilterValueMessage = useStatusFilterValueMessageTranslation();
  return /* @__PURE__ */ React3.createElement(
    Card2.Elevated,
    {
      backgroundColor: "secondary",
      imagePosition: "start",
      css: {
        "&:focus-within": __spreadValues({}, focusOutlineOuter2)
      }
    },
    /* @__PURE__ */ React3.createElement(
      Card2.ClickArea,
      {
        ref: clickAreaRef,
        onCardMouseDown,
        onCardMouseUp,
        css: {
          display: "flex",
          border: "solid $onSurfaceBorderSubdued",
          borderWidth: "$thin"
        },
        imagePosition: "start"
      },
      hasStatusColor && /* @__PURE__ */ React3.createElement(
        Box3,
        {
          css: {
            width: "$half",
            backgroundColor: claimStatusColors.bannerColor
          }
        }
      ),
      /* @__PURE__ */ React3.createElement(
        Card2.Section,
        {
          padding: hasStatusColor ? "$oneAndHalf $one" : "$oneAndHalf"
        },
        /* @__PURE__ */ React3.createElement(
          StackLayout3,
          {
            orientation: { "@initial": "horizontal", "@mobile": "vertical" },
            spacing: "$one",
            verticalAlignment: "center"
          },
          /* @__PURE__ */ React3.createElement(
            StackItem3,
            {
              css: { flex: 3, flexGrow: 0, "@mobile": { width: "100%" } }
            },
            /* @__PURE__ */ React3.createElement(
              StackLayout3,
              {
                spacing: { "@initial": "$threeQuarters", "@mobile": "$half" }
              },
              /* @__PURE__ */ React3.createElement(
                Box3,
                {
                  css: {
                    display: "flex",
                    gap: "$threeQuarters",
                    "@mobile": {
                      width: "100%",
                      justifyContent: "space-between"
                    },
                    alignItems: "center",
                    flexWrap: "wrap"
                  }
                },
                /* @__PURE__ */ React3.createElement(UtilityText2, { as: "p", css: { typography: "$caption" } }, formatDate(serviceDate, CLAIMS_DATE_FORMAT)),
                claimStatusColors && /* @__PURE__ */ React3.createElement(
                  StatusBadge2,
                  {
                    label: status ? getStatusFilterValueMessage(status) : "",
                    status: claimStatusColors.badgeColor,
                    showLight: false
                  }
                )
              ),
              /* @__PURE__ */ React3.createElement(
                UtilityText2,
                {
                  as: "h2",
                  css: {
                    "@mobile": { textOverflow: "ellipsis", marginTop: "10px" }
                  }
                },
                /* @__PURE__ */ React3.createElement(
                  TextAction2,
                  {
                    as: RouterLink,
                    css: { all: "inherit !important" },
                    to: claimDetailsPath,
                    onClick,
                    ref: primaryActionRef
                  },
                  providerName
                )
              ),
              !isAboveMobile && /* @__PURE__ */ React3.createElement(
                MemberNameSection,
                {
                  patientName,
                  identifier,
                  claimType
                }
              ),
              /* @__PURE__ */ React3.createElement(
                Box3,
                {
                  css: {
                    display: "flex",
                    alignItems: "baseline",
                    "@mobile": { marginTop: "$half" }
                  }
                },
                /* @__PURE__ */ React3.createElement(UtilityText2, { as: "p", css: { typography: "$caption" } }, formatMessage({
                  id: "YOUR_COST"
                })),
                /* @__PURE__ */ React3.createElement(
                  HeadingText2,
                  {
                    as: "span",
                    level: "3",
                    size: "lg",
                    css: { paddingInlineStart: "$quarter" }
                  },
                  owedAmountLabel
                )
              )
            )
          ),
          isAboveMobile && /* @__PURE__ */ React3.createElement(
            MemberNameSection,
            {
              patientName,
              identifier,
              claimType
            }
          )
        )
      )
    )
  );
};

// src/components/claims-summary-layout/claims-summary-layout.component.tsx
import * as React4 from "react";
import {
  Box as Box4,
  HeadingText as HeadingText3,
  ParagraphText as ParagraphText2,
  StackLayout as StackLayout4,
  Icon as Icon3,
  useMediaQuery as useMediaQuery3,
  queryHelpers as queryHelpers3
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import { LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES2, getModulePath as getModulePath2 } from "@leagueplatform/core";
import { useGoBack } from "@leagueplatform/web-common";
import { PageHeaderBackground } from "@leagueplatform/web-common-components";
var CLAIMS_SUMMARY_MAX_WIDTH = "1400px";
var CLAIMS_SUMMARY_CONTENT_MAX_WIDTH = "80ch";
function ClaimsBackButton() {
  const { formatMessage } = useIntl5();
  const goBack = useGoBack(getModulePath2(LEAGUE_MODULE_NAMES2.wallet));
  return /* @__PURE__ */ React4.createElement(
    Box4,
    {
      as: "a",
      href: "#",
      onClick: (e) => {
        e.preventDefault();
        goBack();
      },
      id: "go-back",
      css: {
        position: "absolute",
        insetInlineStart: "16px",
        top: "57px",
        width: "hug-Contents",
        "@mobile": {
          display: "inline-block",
          position: "static",
          marginBottom: "$oneAndHalf",
          padding: "$none $oneAndHalf"
        },
        "&:hover, &:active, &:focus": {
          background: "transparent !important",
          transform: "translateX(-3px)"
        }
      }
    },
    /* @__PURE__ */ React4.createElement(
      Icon3,
      {
        icon: "interfaceArrowBack",
        size: {
          "@initial": "$oneAndHalf",
          "@mobile": "$one"
        },
        tint: "$onSurfaceIconPrimary",
        label: formatMessage({ id: "GO_BACK" })
      }
    )
  );
}
var ClaimsSummaryLayout = ({
  isSwoop = false,
  showBackButton = false,
  children,
  banner
}) => {
  const { formatMessage } = useIntl5();
  const isMobile = useMediaQuery3(queryHelpers3.between([0, "tablet"]));
  let headerHeight = isSwoop ? 192 : 166;
  if (isMobile) {
    headerHeight += 100;
  }
  return /* @__PURE__ */ React4.createElement(
    StackLayout4,
    {
      css: {
        margin: "auto",
        height: "auto",
        paddingBlockEnd: "$three"
      },
      spacing: { "@initial": "$three", "@mobile": "$one" }
    },
    /* @__PURE__ */ React4.createElement(
      StackLayout4,
      {
        horizontalAlignment: "center",
        css: {
          width: "100%",
          margin: "auto"
        }
      },
      /* @__PURE__ */ React4.createElement(
        PageHeaderBackground,
        {
          height: `${headerHeight}px`,
          pageHeaderBackgroundHeight: `${headerHeight}px`,
          css: {
            maxWidth: CLAIMS_SUMMARY_MAX_WIDTH,
            width: "100%"
          }
        },
        /* @__PURE__ */ React4.createElement(
          Box4,
          {
            css: {
              position: "relative",
              paddingX: "56px",
              "@mobile": {
                position: "static",
                padding: "$three $none"
              }
            }
          },
          showBackButton && /* @__PURE__ */ React4.createElement(ClaimsBackButton, null),
          /* @__PURE__ */ React4.createElement(
            Box4,
            {
              css: {
                display: "flex",
                alignItems: "flex-start",
                maxWidth: CLAIMS_SUMMARY_MAX_WIDTH,
                width: "100%",
                padding: "$three $none",
                "@mobile": {
                  padding: "$none $oneAndHalf"
                }
              }
            },
            /* @__PURE__ */ React4.createElement(Box4, null, /* @__PURE__ */ React4.createElement(
              HeadingText3,
              {
                level: "1",
                size: {
                  "@initial": "xxl",
                  "@mobile": "xl"
                }
              },
              formatMessage({ id: "CLAIMS_SUMMARY_PAGE_HEADING" })
            ), /* @__PURE__ */ React4.createElement(
              ParagraphText2,
              {
                emphasis: "subtle",
                css: {
                  paddingTop: "$half",
                  maxWidth: CLAIMS_SUMMARY_CONTENT_MAX_WIDTH
                }
              },
              formatMessage({ id: "CLAIMS_SUMMARY_PAGE_SUB_HEADING" })
            ))
          )
        )
      )
    ),
    banner,
    /* @__PURE__ */ React4.createElement(
      Box4,
      {
        css: {
          display: "flex",
          maxWidth: CLAIMS_SUMMARY_MAX_WIDTH,
          margin: "auto",
          flexDirection: "column",
          width: "100%",
          gap: "$one",
          padding: "$none 56px",
          "@mobile": {
            padding: "$none $oneAndHalf"
          }
        }
      },
      children
    )
  );
};

// src/components/claims-filters/radio-filter-input/radio-filter-input.component.tsx
import * as React5 from "react";
import { Fieldset, Radio, StackLayout as StackLayout5 } from "@leagueplatform/genesis-core";
function RadioFilterInput({
  label: groupLabel,
  name: filterName,
  options = [],
  onSubmit,
  value = []
}) {
  const handleOnChange = React5.useCallback(
    (inputValue, inputName) => {
      onSubmit(inputValue, inputName);
    },
    [onSubmit]
  );
  if (options.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React5.createElement(Fieldset, { hideLegend: true, legend: groupLabel }, /* @__PURE__ */ React5.createElement(
    StackLayout5,
    {
      spacing: "$one",
      css: {
        alignItems: "baseline"
      }
    },
    options.map(({ value: optionValue, label, id }) => /* @__PURE__ */ React5.createElement("div", { key: id }, /* @__PURE__ */ React5.createElement(
      Radio,
      {
        id,
        label,
        name: filterName,
        onChange: () => {
          handleOnChange(optionValue, label);
        },
        type: "radio",
        value: optionValue,
        checked: value.includes(optionValue)
      }
    )))
  ));
}

// src/components/claims-filters/checkbox-filter-input/checkbox-filter-input.component.tsx
import * as React6 from "react";
import { xor } from "lodash";
import { Fieldset as Fieldset2, Checkbox, StackLayout as StackLayout6 } from "@leagueplatform/genesis-core";
function CheckboxFilterInput({
  name: filterName,
  label: groupLabel,
  onSubmit,
  options = [],
  value = []
}) {
  const handleOnChange = React6.useCallback(
    (inputValue, inputName) => {
      const newCheckboxValue = xor([inputValue], value).filter(
        (val) => val !== ""
      );
      onSubmit(newCheckboxValue, inputName);
    },
    [value, onSubmit]
  );
  if (options.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React6.createElement(Fieldset2, { hideLegend: true, legend: groupLabel }, /* @__PURE__ */ React6.createElement(
    StackLayout6,
    {
      spacing: "$one",
      css: {
        alignItems: "baseline"
      }
    },
    options.map(({ value: optionValue, label, id }) => {
      const isSelected = value.includes(optionValue);
      return /* @__PURE__ */ React6.createElement("div", { key: id }, /* @__PURE__ */ React6.createElement(
        Checkbox,
        {
          id,
          label,
          name: filterName,
          onChange: () => {
            handleOnChange(optionValue, label);
          },
          type: "Checkbox",
          value: optionValue,
          checked: isSelected
        }
      ));
    })
  ));
}

// src/components/claims-error-state/claims-error-state.component.tsx
import * as React7 from "react";
import { useStaticAsset } from "@leagueplatform/asset-config";
import {
  HeadingText as HeadingText4,
  ImageMessage,
  ParagraphText as ParagraphText3,
  StackLayout as StackLayout7
} from "@leagueplatform/genesis-core";
import {
  useDisplayIsImpersonatorError
} from "@leagueplatform/web-common-components";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
function ClaimsErrorState({
  error,
  image,
  heading,
  message
}) {
  const { formatMessage } = useIntl6();
  const DEFAULT_IMAGE = useStaticAsset(
    "CLAIMS_LIST_EMPTY" /* CLAIMS_LIST_EMPTY */
  );
  const showImpersonationError = useDisplayIsImpersonatorError({ error });
  let genericMessage;
  if (showImpersonationError) {
    genericMessage = formatMessage({ id: "AGENT_PERMISSION_ERROR" });
  } else if (message) {
    genericMessage = message;
  } else {
    genericMessage = formatMessage(
      { id: "CLAIMS_GENERIC_ERROR_MESSAGE" },
      { br: /* @__PURE__ */ React7.createElement("br", null) }
    );
  }
  return /* @__PURE__ */ React7.createElement(ImageMessage, { image: image != null ? image : DEFAULT_IMAGE }, /* @__PURE__ */ React7.createElement(
    StackLayout7,
    {
      spacing: "$half",
      horizontalAlignment: "center",
      css: { textAlign: "center" }
    },
    /* @__PURE__ */ React7.createElement(HeadingText4, { level: "2", size: "md", css: { typography: "$headingThree" } }, heading != null ? heading : formatMessage({ id: "CLAIMS_GENERIC_ERROR_HEADING" })),
    /* @__PURE__ */ React7.createElement(ParagraphText3, null, genericMessage)
  ));
}

// src/components/claims-back-button/claims-back-button.component.tsx
import { styled as styled2, Button } from "@leagueplatform/genesis-core";
var ClaimsBackButton2 = styled2(Button, {
  "&:hover, &:active, &:focus": {
    backgroundColor: "transparent",
    transform: "translateX(-3px)"
  }
});

// src/components/network-coverage-status/network-coverage-status.component.tsx
import * as React8 from "react";
import { Icon as Icon4, ParagraphText as ParagraphText4, StackLayout as StackLayout8 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
var serviceNetworkDict = {
  "in-network": {
    icon: "statusSuccessStatusFilled",
    tint: "$successIcon"
  },
  "out-of-network": {
    icon: "tinyAlert",
    tint: "$warningIcon"
  }
};
function NetworkCoverageStatus({
  serviceNetwork
}) {
  const { $tmap } = useIntl7();
  if (serviceNetworkDict[serviceNetwork] === void 0) {
    return null;
  }
  const label = $tmap({
    "in-network": "CLAIMS_SERVICE_NETWORK_IN_NETWORK",
    "out-of-network": "CLAIMS_SERVICE_NETWORK_OUT_OF_NETWORK"
  })(serviceNetwork);
  const { icon, tint } = serviceNetworkDict[serviceNetwork];
  return /* @__PURE__ */ React8.createElement(
    StackLayout8,
    {
      orientation: "horizontal",
      spacing: "$half",
      verticalAlignment: "center"
    },
    /* @__PURE__ */ React8.createElement(Icon4, { icon, size: "$one", tint }),
    /* @__PURE__ */ React8.createElement(
      ParagraphText4,
      {
        css: {
          typography: "$caption",
          color: "$onSurfaceTextSubdued",
          whiteSpace: "nowrap"
        }
      },
      label
    )
  );
}

// src/components/eob-text-action/eob-text-action.component.tsx
import * as React9 from "react";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import { StackItem as StackItem4, TextAction as TextAction3 } from "@leagueplatform/genesis-core";
var EobTextAction = ({ onClick, loading }) => {
  const { formatMessage } = useIntl8();
  return /* @__PURE__ */ React9.createElement(StackItem4, null, /* @__PURE__ */ React9.createElement(
    TextAction3,
    {
      as: "button",
      size: "medium",
      icon: "interfaceDownload",
      onClick,
      loading
    },
    formatMessage({ id: "DOWNLOAD_BENEFITS_EXPLANATION" })
  ));
};

// src/components/claim-status-preview/claim-status-preview.component.tsx
import * as React10 from "react";
import {
  StackLayout as StackLayout9,
  StackItem as StackItem5,
  ParagraphText as ParagraphText5,
  HeadingText as HeadingText5,
  StatusBadge as StatusBadge3,
  UtilityText as UtilityText3
} from "@leagueplatform/genesis-core";
import { CLAIMS_STATUS_COLORS_MAP as CLAIMS_STATUS_COLORS_MAP2 } from "@leagueplatform/claims-common";
import { SHORT_DATE_FORMAT as SHORT_DATE_FORMAT2 } from "@leagueplatform/web-common";
import { useIntl as useIntl9 } from "@leagueplatform/locales";
var ClaimStatusPreview = ({
  claimDate,
  status,
  providerName,
  providerServiceNetwork,
  patientName,
  identifier,
  claimType,
  groupId,
  isPending,
  showEobDownloadButton,
  onEOBDownloadClick,
  isFetching
}) => {
  var _a;
  const { formatMessage, formatDate } = useIntl9();
  const claimBadgeColor = status && ((_a = CLAIMS_STATUS_COLORS_MAP2[status]) == null ? void 0 : _a.badgeColor);
  const getStatusFilterValueMessage = useStatusFilterValueMessageTranslation();
  return /* @__PURE__ */ React10.createElement(StackLayout9, { spacing: "$one" }, /* @__PURE__ */ React10.createElement(StackLayout9, { orientation: "horizontal", spacing: "$one" }, /* @__PURE__ */ React10.createElement(StackItem5, null, /* @__PURE__ */ React10.createElement(ParagraphText5, { size: "sm" }, formatDate(claimDate, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT2), { timeZone: "UTC" })))), claimBadgeColor && /* @__PURE__ */ React10.createElement(
    StatusBadge3,
    {
      label: status && getStatusFilterValueMessage(status),
      status: claimBadgeColor,
      showLight: false
    }
  )), /* @__PURE__ */ React10.createElement(
    StackLayout9,
    {
      orientation: "horizontal",
      spacing: "$one",
      verticalAlignment: "center",
      css: {
        flexWrap: "wrap"
      }
    },
    /* @__PURE__ */ React10.createElement(HeadingText5, { level: "1", size: "xl" }, providerName),
    providerServiceNetwork && !isPending && /* @__PURE__ */ React10.createElement(NetworkCoverageStatus, { serviceNetwork: providerServiceNetwork })
  ), /* @__PURE__ */ React10.createElement(
    StackLayout9,
    {
      orientation: { "@initial": "horizontal", "@mobile": "vertical" },
      verticalAlignment: "center",
      spacing: { "@initial": "$one", "@mobile": "$quarter" },
      divider: /* @__PURE__ */ React10.createElement(
        UtilityText3,
        {
          size: "sm",
          as: "span",
          "aria-hidden": true,
          css: { "@mobile": { display: "none" } }
        },
        "|"
      ),
      css: {
        flexWrap: "wrap"
      }
    },
    /* @__PURE__ */ React10.createElement(StackItem5, null, /* @__PURE__ */ React10.createElement(ParagraphText5, { size: "sm" }, formatMessage({ id: "CLAIM_PATIENT_NAME" }, { patientName }))),
    !!groupId && /* @__PURE__ */ React10.createElement(StackItem5, null, /* @__PURE__ */ React10.createElement(ParagraphText5, { size: "sm" }, formatMessage({ id: "GROUP_ID" }), ": ", groupId)),
    claimType && /* @__PURE__ */ React10.createElement(ParagraphText5, { size: "sm" }, `${formatMessage(
      {
        id: "CLAIMS_SERVICE_TYPE"
      },
      { type: claimType }
    )} #: ${identifier}`)
  ), showEobDownloadButton && !isPending && /* @__PURE__ */ React10.createElement("div", { "aria-live": "polite" }, /* @__PURE__ */ React10.createElement(EobTextAction, { onClick: onEOBDownloadClick, loading: isFetching })));
};

// src/components/claim-user-cost-card/claim-user-cost-card.component.tsx
import * as React11 from "react";
import {
  StackLayout as StackLayout10,
  ParagraphText as ParagraphText6,
  HeadingText as HeadingText6
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
var ClaimUserCostCard = ({
  isPending = true,
  userCost
}) => {
  const { formatMessage } = useIntl10();
  const owedAmountLabel = useClaimOwedAmountLabel({
    owed: userCost,
    isPending
  });
  const description = isPending ? formatMessage({ id: "CLAIMS_PROCESSING_DESCRIPTION" }) : formatMessage({ id: "CLAIMS_BILL_PROVIDER_DESCRIPTION" });
  return /* @__PURE__ */ React11.createElement(
    StackLayout10,
    {
      horizontalAlignment: "center",
      spacing: "$half",
      css: { textAlign: "center" }
    },
    /* @__PURE__ */ React11.createElement(HeadingText6, { level: "2", size: "sm", css: { typography: "$overline" } }, formatMessage({ id: "CLAIMS_YOUR_COST" })),
    /* @__PURE__ */ React11.createElement(ParagraphText6, { css: { typography: "$headingOne" }, "data-testid": "cost" }, owedAmountLabel),
    /* @__PURE__ */ React11.createElement(
      ParagraphText6,
      {
        css: {
          typography: "$bodyTwo",
          color: "$onSurfaceTextSubdued",
          width: "85%",
          "@mobile": { width: "100%" }
        },
        "data-testid": "description"
      },
      description
    )
  );
};

// src/components/claims-card-list/claims-card-list.component.tsx
import React12 from "react";
import { StackLayout as StackLayout11, Box as Box5 } from "@leagueplatform/genesis-core";
var ClaimsSummaryCardList = ({
  claims,
  onCardClick,
  claimsPath
}) => /* @__PURE__ */ React12.createElement(
  StackLayout11,
  {
    as: "ul",
    spacing: "$oneAndHalf",
    horizontalAlignment: "stretch",
    role: "list",
    css: { marginBottom: "$oneAndHalf" }
  },
  claims.map((claim) => /* @__PURE__ */ React12.createElement(Box5, { as: "li", key: claim.identifier }, /* @__PURE__ */ React12.createElement(
    ClaimCard,
    {
      claimsPath,
      claimType: claim.type,
      identifier: claim.identifier,
      onClick: onCardClick,
      owed: claim.owed,
      patientName: claim.patientName,
      providerName: claim.providerName,
      serviceDate: claim.serviceDate,
      showColorBar: true,
      status: claim.status
    }
  )))
);
var ClaimsCardList = ({
  claims,
  onCardClick,
  claimsPath
}) => /* @__PURE__ */ React12.createElement(
  StackLayout11,
  {
    as: "ul",
    horizontalAlignment: "stretch",
    role: "list",
    spacing: "$oneAndHalf",
    css: { height: "auto" }
  },
  claims.map((claim) => {
    var _a;
    return /* @__PURE__ */ React12.createElement(Box5, { as: "li", key: claim.identifier }, /* @__PURE__ */ React12.createElement(
      ClaimCard,
      {
        claimsPath,
        claimType: claim.claimType,
        identifier: claim.identifier,
        onClick: onCardClick,
        owed: (_a = claim.totals) == null ? void 0 : _a.owed,
        patientName: claim.patientName,
        providerName: claim.providerName,
        serviceDate: claim.serviceDate,
        showColorBar: true,
        status: claim.status
      }
    ));
  })
);

// src/components/member-cost-breakdown/member-cost-breakdown.component.tsx
import * as React13 from "react";
import { StackLayout as StackLayout12, UtilityText as UtilityText4 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import { useFormatClaimsValue as useFormatClaimsValue2 } from "@leagueplatform/claims-common";
function MemberCostBreakdown({ costData }) {
  const { formatMessage } = useIntl11();
  const formatClaimsValue = useFormatClaimsValue2();
  if (!costData.length) {
    return null;
  }
  return /* @__PURE__ */ React13.createElement(
    StackLayout12,
    {
      spacing: "$one",
      horizontalAlignment: "stretch",
      css: { paddingInlineStart: "$threeQuarters" }
    },
    /* @__PURE__ */ React13.createElement(StackLayout12, { spacing: "$quarter" }, /* @__PURE__ */ React13.createElement(
      UtilityText4,
      {
        as: "h4",
        css: { typography: "$label", color: "$onSurfaceTextSubdued" }
      },
      formatMessage({
        id: "CLAIMS_SERVICE_DETAILS_YOUR_COST_BREAKDOWN_HEADING"
      })
    ), /* @__PURE__ */ React13.createElement(
      UtilityText4,
      {
        as: "p",
        css: { typography: "$caption", color: "$onSurfaceTextSubdued" }
      },
      formatMessage({
        id: "CLAIMS_SERVICE_DETAILS_YOUR_COST_BREAKDOWN_SUBHEADING"
      })
    )),
    /* @__PURE__ */ React13.createElement(StackLayout12, { as: "ul", spacing: "$one", horizontalAlignment: "stretch" }, costData.map((line) => /* @__PURE__ */ React13.createElement(
      StackLayout12,
      {
        key: line.code,
        as: "li",
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$half"
      },
      /* @__PURE__ */ React13.createElement(
        StackLayout12,
        {
          orientation: "horizontal",
          verticalAlignment: "center",
          horizontalAlignment: "spaceBetween"
        },
        /* @__PURE__ */ React13.createElement(
          StackLayout12,
          {
            orientation: "horizontal",
            spacing: "$quarter",
            verticalAlignment: "center"
          },
          /* @__PURE__ */ React13.createElement(
            UtilityText4,
            {
              css: {
                typography: "$bodyTwo",
                color: "$onSurfaceTextSubdued"
              }
            },
            formatMessage(
              { id: "CLAIMS_SERVICE_LINE_ITEM_LABEL" },
              { code: line.code }
            ),
            " "
          )
        ),
        /* @__PURE__ */ React13.createElement(
          UtilityText4,
          {
            css: { typography: "$bodyTwo", color: "$onSurfaceTextSubdued" }
          },
          formatClaimsValue({
            amount: line.amount,
            currencyCode: line.currencyCode
          })
        )
      )
    )))
  );
}

// src/components/claims-helpful-links/claims-helpful-links.component.tsx
import React15 from "react";
import { uniqueId } from "lodash";
import {
  StackLayout as StackLayout14,
  TextAction as TextAction4,
  Box as Box7,
  ParagraphText as ParagraphText8,
  Responsive,
  Modal,
  Button as Button2,
  HeadingText as HeadingText7
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl13 } from "@leagueplatform/locales";

// src/components/claims-status-definitions/claims-status-definitions.component.tsx
import * as React14 from "react";
import { useIntl as useIntl12 } from "@leagueplatform/locales";
import {
  StatusBadge as StatusBadge4,
  Box as Box6,
  ParagraphText as ParagraphText7,
  StackLayout as StackLayout13
} from "@leagueplatform/genesis-core";
import { CLAIMS_STATUS_COLORS_MAP as CLAIMS_STATUS_COLORS_MAP3 } from "@leagueplatform/claims-common";
var ClaimsStatusDefinition = ({
  statuses
}) => {
  const { $tmap } = useIntl12();
  const statusMessage = $tmap({
    approved: "CLAIMS_FILTER_VALUE_APPROVED",
    pending: "CLAIMS_FILTER_VALUE_PENDING",
    partially_paid: "CLAIMS_FILTER_VALUE_PARTIALLY_PAID",
    not_covered: "CLAIMS_FILTER_VALUE_NOT_COVERED",
    adjusted: "CLAIMS_FILTER_VALUE_ADJUSTED"
  });
  const statusDefinitionMessage = $tmap(
    {
      approved: "CLAIMS_STATUS_DEFINITION_APPROVED",
      pending: "CLAIMS_STATUS_DEFINITION_PENDING",
      partially_paid: "CLAIMS_STATUS_DEFINITION_PARTIALLY_PAID",
      not_covered: "CLAIMS_STATUS_DEFINITION_NOT_COVERED",
      adjusted: "CLAIMS_STATUS_DEFINITION_ADJUSTED"
    }
  );
  return /* @__PURE__ */ React14.createElement(StackLayout13, { spacing: "$oneAndHalf" }, statuses.map((status) => {
    var _a;
    const claimBadgeColor = (_a = CLAIMS_STATUS_COLORS_MAP3[status]) == null ? void 0 : _a.badgeColor;
    return /* @__PURE__ */ React14.createElement(
      Box6,
      {
        css: {
          display: "flex",
          gap: "$threeQuarters",
          flexDirection: "column"
        },
        key: status
      },
      claimBadgeColor && /* @__PURE__ */ React14.createElement(
        StatusBadge4,
        {
          label: statusMessage(status),
          status: claimBadgeColor,
          showLight: false,
          css: { width: "max-content" }
        }
      ),
      /* @__PURE__ */ React14.createElement(ParagraphText7, { size: "sm" }, statusDefinitionMessage(status))
    );
  }));
};

// src/components/claims-helpful-links/claims-helpful-links.component.tsx
var renderAsParagraph = (msg) => /* @__PURE__ */ React15.createElement(ParagraphText8, null, msg);
var CLAIMS_STATUS_DEFINITIONS_ID = "claim-status-definitions-section";
var CLAIMS_STATUS_DEFINITIONS_BUTTON_ID = `${CLAIMS_STATUS_DEFINITIONS_ID}-control`;
var DEFAULT_HEALTH_INSURANCE_GLOSSARY_ROUTE = "/glossary";
function ClaimsHelpfulLinks({
  showClaimStatusDefinitions,
  showDownloadClaims = false,
  isDownloadingClaims = false,
  onDownloadClaimsClick,
  onHowClaimsWorkToggle,
  onStatusDefinitionsToggle,
  claimStatuses,
  onHealthInsuranceGlossaryClick,
  showHealthInsuranceGlossary = false,
  healthInsuranceGlossaryLink
}) {
  const [showDefinitions, setShowDefinitions] = React15.useState(false);
  const [showHowClaimsWork, setShowHowClaimsWork] = React15.useState(false);
  const { formatMessage } = useIntl13();
  const toggleDefinitions = () => setShowDefinitions(!showDefinitions);
  const toggleHowClaimsWork = () => setShowHowClaimsWork(!showHowClaimsWork);
  const mobileHowClaimsWorkSectionId = React15.useMemo(
    () => uniqueId("mobile-how-claims-work-content-section"),
    []
  );
  const mobileHowClaimsWorkButtonId = React15.useMemo(
    () => uniqueId("mobile-how-claims-work-content-section"),
    []
  );
  return /* @__PURE__ */ React15.createElement(StackLayout14, { spacing: "$oneAndHalf", css: { padding: "$oneAndHalf" } }, showDownloadClaims && /* @__PURE__ */ React15.createElement(
    TextAction4,
    {
      as: "button",
      size: "medium",
      onClick: onDownloadClaimsClick,
      icon: "interfaceDownload",
      loading: isDownloadingClaims,
      css: {
        whiteSpace: "nowrap"
      }
    },
    formatMessage({ id: "DOWNLOAD_CLAIMS" })
  ), /* @__PURE__ */ React15.createElement(StackLayout14, { spacing: "$none" }, /* @__PURE__ */ React15.createElement(Responsive, { up: "mobileLandscape" }, /* @__PURE__ */ React15.createElement(Modal.Root, null, /* @__PURE__ */ React15.createElement(Modal.Trigger, null, /* @__PURE__ */ React15.createElement(
    TextAction4,
    {
      icon: "descriptiveQuestionBox",
      as: "button",
      size: "medium"
    },
    formatMessage({ id: "HOW_CLAIMS_WORK" })
  )), /* @__PURE__ */ React15.createElement(Modal.Content, { padding: "$none $oneAndHalf $oneAndHalf" }, /* @__PURE__ */ React15.createElement(StackLayout14, { spacing: "$one" }, /* @__PURE__ */ React15.createElement(Modal.Title, null, /* @__PURE__ */ React15.createElement(HeadingText7, { level: "2", size: "lg" }, formatMessage({
    id: "UNDERSTANDING_HOW_YOUR_CLAIMS_WORK_TITLE"
  }))), /* @__PURE__ */ React15.createElement(Modal.Description, null, /* @__PURE__ */ React15.createElement(Box7, null, formatMessage(
    { id: "UNDERSTANDING_HOW_YOUR_CLAIMS_WORK_TEXT" },
    { p: renderAsParagraph }
  ))), /* @__PURE__ */ React15.createElement(
    Box7,
    {
      css: {
        display: "flex",
        justifyContent: "flex-end",
        width: "100%"
      }
    },
    /* @__PURE__ */ React15.createElement(Modal.Close, null, /* @__PURE__ */ React15.createElement(Button2, { priority: "primary" }, formatMessage({ id: "OK" })))
  ))))), /* @__PURE__ */ React15.createElement(Responsive, { down: "mobileLandscape" }, /* @__PURE__ */ React15.createElement(Box7, { as: "h3", css: { margin: 0 } }, /* @__PURE__ */ React15.createElement(
    TextAction4,
    {
      as: "button",
      size: "medium",
      "aria-expanded": showHowClaimsWork,
      "aria-controls": mobileHowClaimsWorkSectionId,
      id: mobileHowClaimsWorkButtonId,
      onClick: () => {
        toggleHowClaimsWork();
        onHowClaimsWorkToggle == null ? void 0 : onHowClaimsWorkToggle(showHowClaimsWork);
      },
      icon: showHowClaimsWork ? "interfaceChevronUp" : "interfaceChevronDown",
      css: {
        flexDirection: "row-reverse",
        gap: "$half",
        whiteSpace: "nowrap"
      }
    },
    formatMessage({ id: "HOW_CLAIMS_WORK" })
  )), /* @__PURE__ */ React15.createElement(
    Box7,
    {
      "aria-labelledby": mobileHowClaimsWorkButtonId,
      as: "section",
      id: mobileHowClaimsWorkSectionId,
      hidden: !showHowClaimsWork,
      css: {
        paddingTop: "$one",
        display: showHowClaimsWork ? "block" : "none"
      }
    },
    formatMessage(
      { id: "UNDERSTANDING_HOW_YOUR_CLAIMS_WORK_TEXT" },
      { p: renderAsParagraph }
    )
  ))), showHealthInsuranceGlossary && /* @__PURE__ */ React15.createElement(
    TextAction4,
    {
      as: "a",
      href: healthInsuranceGlossaryLink || `${DEFAULT_HEALTH_INSURANCE_GLOSSARY_ROUTE}`,
      size: "medium",
      onClick: onHealthInsuranceGlossaryClick,
      icon: "statusInformationCircle2"
    },
    formatMessage({ id: "HEALTH_INSURANCE_GLOSSARY" })
  ), showClaimStatusDefinitions && /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement(Box7, { as: "h3", css: { margin: 0 } }, /* @__PURE__ */ React15.createElement(
    TextAction4,
    {
      as: "button",
      size: "medium",
      "aria-expanded": showDefinitions,
      "aria-controls": CLAIMS_STATUS_DEFINITIONS_ID,
      id: CLAIMS_STATUS_DEFINITIONS_BUTTON_ID,
      onClick: () => {
        toggleDefinitions();
        onStatusDefinitionsToggle == null ? void 0 : onStatusDefinitionsToggle(showDefinitions);
      },
      icon: showDefinitions ? "interfaceChevronUp" : "interfaceChevronDown",
      css: {
        flexDirection: "row-reverse",
        gap: "$half",
        whiteSpace: "nowrap"
      }
    },
    formatMessage({ id: "CLAIMS_STATUS_DEFINITIONS" })
  )), /* @__PURE__ */ React15.createElement(
    Box7,
    {
      hidden: !showDefinitions,
      "aria-labelledby": CLAIMS_STATUS_DEFINITIONS_BUTTON_ID,
      as: "section",
      id: CLAIMS_STATUS_DEFINITIONS_ID
    },
    showDefinitions && /* @__PURE__ */ React15.createElement(ClaimsStatusDefinition, { statuses: claimStatuses })
  )));
}

// src/components/claims-summary-sidebar/claims-summary-sidebar.component.tsx
import * as React16 from "react";
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import { SectionHeader } from "@leagueplatform/genesis-core-alpha";
import { Box as Box8, StackLayout as StackLayout15, styled as styled3 } from "@leagueplatform/genesis-core";
var LinkSidebar = styled3(Box8, {
  marginBottom: "$two",
  paddingTop: "$oneAndHalf",
  borderWidth: "$thin",
  borderStyle: "solid",
  borderColor: "$onSurfaceBorderSubdued",
  borderRadius: "$medium"
});
var ClaimsSummarySidebar = ({
  children
}) => {
  const { formatMessage } = useIntl14();
  return /* @__PURE__ */ React16.createElement(LinkSidebar, null, /* @__PURE__ */ React16.createElement(StackLayout15, { spacing: "$none" }, /* @__PURE__ */ React16.createElement(
    SectionHeader,
    {
      title: formatMessage({ id: "HELPFUL_LINKS" }),
      css: {
        paddingInlineStart: "$oneAndHalf"
      },
      headingLevel: "2"
    }
  ), children));
};

// src/components/claims-summary-sidebar-mobile/claims-summary-sidebar-mobile.component.tsx
import { Divider, StackItem as StackItem6, TextAction as TextAction5 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl16 } from "@leagueplatform/locales";
import * as React18 from "react";

// src/components/how-claims-work-modal/how-claims-work-modal.component.tsx
import * as React17 from "react";
import {
  Button as Button3,
  HeadingText as HeadingText8,
  Modal as Modal2,
  HeadingBar
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl15 } from "@leagueplatform/locales";
function HowClaimsWorkModalTrigger({
  children,
  renderHelpfulLinks,
  onClose
}) {
  const { formatMessage } = useIntl15();
  return /* @__PURE__ */ React17.createElement(Modal2.Root, null, /* @__PURE__ */ React17.createElement(Modal2.Trigger, null, children), /* @__PURE__ */ React17.createElement(Modal2.Content, { layout: "inlineEnd", showCloseButton: false, padding: "$none" }, /* @__PURE__ */ React17.createElement(
    HeadingBar,
    {
      trailingAction: /* @__PURE__ */ React17.createElement(Modal2.Close, null, /* @__PURE__ */ React17.createElement(
        Button3,
        {
          priority: "tertiary",
          quiet: true,
          icon: "tinyClose",
          hideLabel: true,
          size: "small",
          onClick: onClose
        },
        formatMessage({ id: "CLOSE" })
      )),
      title: /* @__PURE__ */ React17.createElement(Modal2.Title, null, /* @__PURE__ */ React17.createElement(HeadingText8, { level: "4", size: "md" }, formatMessage({ id: "HELPFUL_LINKS" })))
    }
  ), renderHelpfulLinks));
}

// src/components/claims-summary-sidebar-mobile/claims-summary-sidebar-mobile.component.tsx
function ClaimsSummarySidebarMobile({
  onHelpfulLinksClick,
  renderHelpfulLinks,
  onModalClose
}) {
  const { formatMessage } = useIntl16();
  return /* @__PURE__ */ React18.createElement(StackItem6, null, /* @__PURE__ */ React18.createElement(
    HowClaimsWorkModalTrigger,
    {
      renderHelpfulLinks,
      onClose: onModalClose
    },
    /* @__PURE__ */ React18.createElement(
      TextAction5,
      {
        as: "button",
        icon: "interfaceChevronForward",
        onClick: onHelpfulLinksClick,
        css: {
          width: "100%",
          display: "flex",
          flexDirection: "row-reverse",
          justifyContent: "space-between",
          color: "$onSurfaceTextSubdued",
          padding: "$one $none"
        }
      },
      formatMessage({ id: "HELPFUL_LINKS" })
    )
  ), /* @__PURE__ */ React18.createElement(
    Divider,
    {
      css: {
        position: "relative",
        width: "100vw",
        insetInlineStart: "$minusOneAndHalf"
      }
    }
  ));
}

// src/components/claims-list-filters/claims-list-filters.component.tsx
import * as React24 from "react";
import {
  Box as Box11,
  StackLayout as StackLayout18,
  TextAction as TextAction7,
  UtilityText as UtilityText5
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl21 } from "@leagueplatform/locales";

// src/components/claims-list-filters/components/claims-filter/claims-filter.component.tsx
import * as React21 from "react";
import { useIntl as useIntl18 } from "@leagueplatform/locales";
import { Box as Box10, Fieldset as Fieldset3, Spinner } from "@leagueplatform/genesis-core";

// src/components/claims-list-filters/hooks/use-applied-filter-count.hook.ts
import {
  useClaimsFilters,
  useSelectedDateRange
} from "@leagueplatform/claims-common";
function useAppliedFilterCount(filterType) {
  var _a;
  const filters = useClaimsFilters();
  const selectedDateRange = useSelectedDateRange();
  const filterValues = (_a = filters[filterType]) != null ? _a : [];
  if (filterType === "serviceDate") {
    return selectedDateRange ? 1 : 0;
  }
  return filterValues.length;
}

// src/components/claims-filters/filter-dropdown/filter-dropdown.component.tsx
import {
  styled as styled4,
  Popover,
  GDSPopoverPrimitive
} from "@leagueplatform/genesis-core";
import { uniqueId as uniqueId2 } from "lodash";
import * as React19 from "react";
var MAX_POPOVER_HEIGHT = "450px";
var PopoverContent = styled4(Popover.Content, {
  zIndex: "$default",
  maxHeight: MAX_POPOVER_HEIGHT,
  overflowY: "auto",
  position: "relative"
});
var ClaimsFilterTriggerSelect = styled4(Popover.Trigger, {
  display: "flex",
  flexDirection: "row-reverse",
  appearance: "none",
  gap: "$half",
  svg: {
    color: "$onSurfaceIconPrimary"
  },
  minWidth: "max-content"
});
function FilterDropdown({
  children,
  label,
  labelById,
  onClick: onClickCallback
}) {
  const [isFilterDropdownOpen, setFilterDropdownState] = React19.useState(false);
  const [isFocusOnButton, setIsFocusOnButton] = React19.useState(false);
  const id = uniqueId2("filter-dropdown");
  const toggleFocus = () => setIsFocusOnButton(!isFocusOnButton);
  const toggleDropdown = () => setFilterDropdownState(!isFilterDropdownOpen);
  return /* @__PURE__ */ React19.createElement(Popover.Root, { onOpenChange: () => toggleDropdown() }, /* @__PURE__ */ React19.createElement(
    ClaimsFilterTriggerSelect,
    {
      id,
      "aria-labelledby": `${labelById} ${id}`,
      css: {
        backgroundColor: "$inputBackgroundDefault",
        border: "$borderWidths$thin solid $inputBorderDefault",
        borderRadius: "$medium",
        typography: "$bodyTwo",
        color: "$onSurfaceTextPrimary",
        padding: "$threeQuarters $half",
        paddingInlineStart: "$one",
        "&:hover": {
          borderColor: isFocusOnButton ? "$interactiveFocusInner" : "$inputBorderHovered",
          backgroundColor: "$inputBackgroundHovered"
        },
        '&[class*="GDS"]:focus, &:active, &[aria-expanded="true"]': {
          borderColor: "transparent",
          boxShadow: "inset 0 0 0 $borderWidths$innerFocus $colors$interactiveFocusInner",
          // Visible in Windows high-contrast themes
          outline: "$borderWidths$innerFocus solid transparent",
          backgroundColor: "$inputBackgroundDefault"
        },
        outline: "$borderWidths$innerFocus solid transparent"
      },
      label,
      icon: isFilterDropdownOpen ? "interfaceChevronUp" : "interfaceChevronDown",
      onClick: (event) => {
        event.currentTarget.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest"
        });
        if (onClickCallback) {
          onClickCallback();
        }
      }
    }
  ), /* @__PURE__ */ React19.createElement(GDSPopoverPrimitive.Portal, null, /* @__PURE__ */ React19.createElement(
    PopoverContent,
    {
      avoidCollisions: true,
      align: "start",
      showCloseButton: false,
      onOpenAutoFocus: () => toggleFocus(),
      onCloseAutoFocus: () => toggleFocus(),
      sideOffset: 12,
      css: {
        border: isFilterDropdownOpen ? "$borderWidths$thin solid $interactiveActionPrimary" : "none"
      }
    },
    children
  )));
}

// src/components/claims-list-filters/components/filter-options/filter-options.component.tsx
import * as React20 from "react";
import {
  Box as Box9,
  Checkbox as Checkbox2,
  Radio as Radio2,
  StackLayout as StackLayout16
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl17 } from "@leagueplatform/locales";
import {
  useDateRange,
  useToggleClaimsFilter
} from "@leagueplatform/claims-common";

// src/components/claims-list-filters/hooks/use-get-is-option-selected.hook.ts
import {
  useClaimsFilters as useClaimsFilters2,
  useSelectedDateRange as useSelectedDateRange2
} from "@leagueplatform/claims-common";
function useGetIsOptionSelected() {
  const filters = useClaimsFilters2();
  const selectedDateRange = useSelectedDateRange2();
  return (filterType, filterValue) => {
    const selectedOptions = filters[filterType];
    const isOptionSelected = selectedOptions == null ? void 0 : selectedOptions.find(
      (selectedOption) => selectedOption.value === filterValue
    );
    return selectedOptions && !!isOptionSelected || selectedDateRange === filterValue;
  };
}

// src/components/claims-list-filters/components/filter-options/filter-options.component.tsx
function FilterOptions({
  filterValues,
  filterType,
  onFilterChange
}) {
  const { $tmap } = useIntl17();
  const toggleFilter = useToggleClaimsFilter();
  const changeDateRange = useDateRange();
  const getIsOptionSelected = useGetIsOptionSelected();
  const isRadio = filterType === "serviceDate";
  const isLocalizedValue = ["status", "serviceDate", "type"].includes(
    filterType
  );
  const filterValueMessage = $tmap({
    oral: "CLAIMS_FILTER_VALUE_ORAL",
    institutional: "CLAIMS_FILTER_VALUE_INSTITUTIONAL",
    vision: "CLAIMS_FILTER_VALUE_VISION",
    pharmacy: "CLAIMS_FILTER_VALUE_PHARMACY",
    professional: "CLAIMS_FILTER_VALUE_PROFESSIONAL",
    approved: "CLAIMS_FILTER_VALUE_APPROVED",
    pending: "CLAIMS_FILTER_VALUE_PENDING",
    partially_paid: "CLAIMS_FILTER_VALUE_PARTIALLY_PAID",
    not_covered: "CLAIMS_FILTER_VALUE_NOT_COVERED",
    adjusted: "CLAIMS_FILTER_VALUE_ADJUSTED",
    year_to_date: "CLAIMS_FILTER_VALUE_YEAR_TO_DATE",
    prior_year: "CLAIMS_FILTER_VALUE_PRIOR_YEAR",
    last_12_months: "CLAIMS_FILTER_VALUE_LAST_12_MONTHS",
    last_2_years: "CLAIMS_FILTER_VALUE_LAST_2_YEARS"
  });
  return /* @__PURE__ */ React20.createElement(
    StackLayout16,
    {
      as: "ul",
      spacing: "$one",
      css: {
        alignItems: "baseline"
      }
    },
    filterValues.map((filterValue) => {
      let filterDisplayValue = filterValue;
      if (isLocalizedValue) {
        filterDisplayValue = filterValueMessage(filterValue);
      }
      const isOptionSelected = getIsOptionSelected(filterType, filterValue);
      return /* @__PURE__ */ React20.createElement(Box9, { as: "li", key: filterValue }, isRadio ? /* @__PURE__ */ React20.createElement(
        Radio2,
        {
          type: "radio",
          label: filterDisplayValue,
          name: filterType,
          id: filterValue,
          onChange: () => {
            changeDateRange({ selectedDateRange: filterValue });
            onFilterChange == null ? void 0 : onFilterChange(isOptionSelected, filterType);
          },
          checked: isOptionSelected
        }
      ) : /* @__PURE__ */ React20.createElement(
        Checkbox2,
        {
          id: filterValue,
          label: filterDisplayValue,
          name: filterValue,
          onChange: () => {
            toggleFilter({ [filterType]: filterValue });
            onFilterChange == null ? void 0 : onFilterChange(isOptionSelected, filterType);
          },
          checked: isOptionSelected,
          css: {
            ".GDS-checkbox-label-text": {
              marginBlockEnd: "$none"
            }
          }
        }
      ));
    })
  );
}

// src/components/claims-list-filters/components/claims-filter/claims-filter.component.tsx
function ClaimsFilter({
  filterValues,
  filterType,
  isLoading,
  onFilterTypeClick,
  onFilterChange
}) {
  const { $tmap } = useIntl18();
  const filterCount = useAppliedFilterCount(filterType);
  const filterName = $tmap({
    identifier: "CLAIMS_FILTER_PROPERTY_IDENTIFIER",
    patientName: "CLAIMS_FILTER_PROPERTY_PATIENTNAME",
    status: "CLAIMS_FILTER_PROPERTY_STATUS",
    createdDate: "CLAIMS_FILTER_PROPERTY_CREATEDDATE",
    serviceDate: "CLAIMS_FILTER_PROPERTY_SERVICEDATE",
    providerName: "CLAIMS_FILTER_PROPERTY_PROVIDERNAME",
    relationship: "CLAIMS_FILTER_PROPERTY_RELATIONSHIP",
    type: "CLAIMS_FILTER_PROPERTY_TYPE"
  })(filterType);
  const filterCountLabel = filterCount > 0 ? ` (${filterCount})` : "";
  const label = `${filterName}${filterCountLabel}`;
  return /* @__PURE__ */ React21.createElement(
    FilterDropdown,
    {
      label,
      onClick: () => {
        if (onFilterTypeClick) {
          onFilterTypeClick(filterType);
        }
      }
    },
    isLoading && /* @__PURE__ */ React21.createElement(Box10, { css: { padding: "$five" } }, /* @__PURE__ */ React21.createElement(Spinner, { loading: isLoading })),
    !isLoading && /* @__PURE__ */ React21.createElement(Fieldset3, { legend: filterType, hideLegend: true }, /* @__PURE__ */ React21.createElement(
      FilterOptions,
      {
        filterType,
        filterValues,
        onFilterChange
      }
    ))
  );
}

// src/components/claims-list-filters/components/filter-chip/filter-chips-container.component.tsx
import * as React23 from "react";
import { StackLayout as StackLayout17, TextAction as TextAction6 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl20 } from "@leagueplatform/locales";
import {
  useClaimsFilters as useClaimsFilters3,
  useSelectedDateRange as useSelectedDateRange3,
  useSelectedDateRangeTimestamp
} from "@leagueplatform/claims-common";

// src/components/claims-list-filters/utils/create-filterchip-objects-function.util.ts
function createFilterchipObjects(selectedFilters) {
  const filterEntries = Object.entries(selectedFilters);
  const formattedFilters = filterEntries.reduce(
    (prevReturn, [currentFilterType, currentFilterValues = []]) => {
      const validValues = currentFilterValues == null ? void 0 : currentFilterValues.filter(
        (value) => !!value
      );
      const formattedSelectedValues = validValues.map(
        (value) => ({
          type: currentFilterType,
          value
        })
      );
      if (formattedSelectedValues) {
        return [...prevReturn, ...formattedSelectedValues];
      }
      return prevReturn;
    },
    []
  );
  return formattedFilters;
}

// src/components/claims-list-filters/components/filter-chip/filter-chip.component.tsx
import * as React22 from "react";
import { Button as Button4 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
import {
  useDateRange as useDateRange2,
  useToggleClaimsFilter as useToggleClaimsFilter2
} from "@leagueplatform/claims-common";
function FilterChip({ filterValue, filterType }) {
  const { $tmap } = useIntl19();
  const toggleFilter = useToggleClaimsFilter2();
  const changeDateRange = useDateRange2();
  const isLocalizedValue = ["status", "serviceDate", "type"].includes(
    filterType
  );
  const isServiceDate = filterType === "serviceDate";
  let filterDisplayValue = filterValue.value;
  const filterValueMessage = $tmap({
    oral: "CLAIMS_FILTER_VALUE_ORAL",
    institutional: "CLAIMS_FILTER_VALUE_INSTITUTIONAL",
    vision: "CLAIMS_FILTER_VALUE_VISION",
    pharmacy: "CLAIMS_FILTER_VALUE_PHARMACY",
    professional: "CLAIMS_FILTER_VALUE_PROFESSIONAL",
    approved: "CLAIMS_FILTER_VALUE_APPROVED",
    pending: "CLAIMS_FILTER_VALUE_PENDING",
    partially_paid: "CLAIMS_FILTER_VALUE_PARTIALLY_PAID",
    not_covered: "CLAIMS_FILTER_VALUE_NOT_COVERED",
    adjusted: "CLAIMS_FILTER_VALUE_ADJUSTED",
    year_to_date: "CLAIMS_FILTER_VALUE_YEAR_TO_DATE",
    prior_year: "CLAIMS_FILTER_VALUE_PRIOR_YEAR",
    last_12_months: "CLAIMS_FILTER_VALUE_LAST_12_MONTHS",
    last_2_years: "CLAIMS_FILTER_VALUE_LAST_2_YEARS"
  });
  if (isLocalizedValue && filterValue.value) {
    filterDisplayValue = filterValueMessage(filterValue.value);
  }
  return /* @__PURE__ */ React22.createElement(
    Button4,
    {
      priority: "secondary",
      icon: "tinyClose",
      onClick: isServiceDate ? () => changeDateRange({ selectedDateRange: void 0 }) : () => toggleFilter({ [filterType]: filterValue.value }),
      css: {
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        typography: "$caption",
        borderRadius: "8px",
        backgroundColor: "$surfaceBackgroundSecondary",
        color: "$onSurfaceTextPrimary",
        borderColor: "$interactiveActionPrimary",
        paddingTop: "4px",
        paddingBottom: "4px",
        paddingInlineStart: "0",
        paddingInlineEnd: "8px",
        whiteSpace: "nowrap",
        svg: {
          width: "10px",
          height: "10px",
          color: "$interactiveActionPrimary"
        },
        "& > *": {
          paddingInlineStart: "8px",
          paddingInlineEnd: "0"
        },
        "&:hover": {
          backgroundColor: "$surfaceBackgroundTertiary",
          borderColor: "$interactiveActionPrimary",
          color: "$onSurfaceTextPrimary"
        }
      }
    },
    filterDisplayValue
  );
}

// src/components/claims-list-filters/components/filter-chip/filter-chips-container.component.tsx
function useFilterChips() {
  const selectedFilters = useClaimsFilters3();
  const selectedDateRange = useSelectedDateRange3();
  const selectedDateRangeTimestamp = useSelectedDateRangeTimestamp();
  let formattedSelectedFilters = createFilterchipObjects(selectedFilters);
  if (selectedDateRange && selectedDateRangeTimestamp) {
    const dateObject = {
      type: "serviceDate",
      value: {
        value: selectedDateRange,
        timestamp: selectedDateRangeTimestamp
      }
    };
    formattedSelectedFilters = [...formattedSelectedFilters, dateObject];
  }
  return formattedSelectedFilters;
}
function FilterChipsContainer({
  onClearFiltersClick,
  allowClearFilters
}) {
  const { formatMessage } = useIntl20();
  const formattedSelectedFilters = useFilterChips();
  if (formattedSelectedFilters.length > 0) {
    return /* @__PURE__ */ React23.createElement(
      StackLayout17,
      {
        orientation: "horizontal",
        spacing: "$threeQuarters $one",
        verticalAlignment: "center",
        css: {
          flexWrap: "wrap",
          paddingTop: "$one",
          paddingBottom: "$half",
          paddingInlineStart: "$oneAndHalf",
          "@mobile": {
            flexWrap: "nowrap",
            width: "100%",
            overflowX: "auto",
            paddingInlineEnd: "$oneAndHalf"
          }
        }
      },
      formattedSelectedFilters.sort((a, b) => b.value.timestamp - a.value.timestamp).map((selectedFilter) => /* @__PURE__ */ React23.createElement(
        FilterChip,
        {
          key: selectedFilter.value.timestamp,
          filterValue: selectedFilter.value,
          filterType: selectedFilter.type
        }
      )),
      allowClearFilters && /* @__PURE__ */ React23.createElement(
        TextAction6,
        {
          size: "medium",
          onClick: onClearFiltersClick,
          css: {
            whiteSpace: "nowrap"
          }
        },
        formatMessage({ id: "CLEAR_ALL" })
      )
    );
  }
  return null;
}

// src/components/claims-list-filters/claims-list-filters.component.tsx
function ClaimsListFilters({
  filters,
  onClearFiltersClick,
  allowClearFilters,
  showFilterChips,
  isLoading,
  onFilterChange,
  onFilterTypeClick
}) {
  const { formatMessage } = useIntl21();
  return /* @__PURE__ */ React24.createElement(StackLayout18, { spacing: "$threeQuarters" }, /* @__PURE__ */ React24.createElement(UtilityText5, { size: "eyebrow" }, formatMessage({ id: "FILTER_BY" })), /* @__PURE__ */ React24.createElement(
    Box11,
    {
      css: {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        margin: "$none $minusOneAndHalf",
        "@mobile": {
          flexWrap: "nowrap"
        }
      }
    },
    /* @__PURE__ */ React24.createElement(
      Box11,
      {
        css: {
          display: "flex",
          flexDirection: "column",
          "@mobile": {
            overflowX: "auto",
            marginInlineEnd: "-50px"
          }
        }
      },
      /* @__PURE__ */ React24.createElement(
        Box11,
        {
          css: {
            display: "flex",
            alignItems: "center",
            padding: "$none $oneAndHalf",
            width: "100%",
            gap: "$half",
            "@mobile": {
              overflowX: "auto"
            }
          }
        },
        filters.map(({ filterType, filterValues }) => /* @__PURE__ */ React24.createElement(
          ClaimsFilter,
          {
            filterType,
            filterValues,
            key: filterType,
            isLoading,
            onFilterChange,
            onFilterTypeClick
          }
        ))
      ),
      showFilterChips && /* @__PURE__ */ React24.createElement(
        FilterChipsContainer,
        {
          onClearFiltersClick,
          allowClearFilters
        }
      ),
      !showFilterChips && allowClearFilters && /* @__PURE__ */ React24.createElement(
        TextAction7,
        {
          as: "button",
          size: "medium",
          onClick: onClearFiltersClick,
          css: { paddingInlineStart: "$oneAndHalf" }
        },
        formatMessage({ id: "CLEAR_ALL" })
      )
    )
  ));
}

// src/components/supporting-card/supporting-card.component.tsx
import React25 from "react";
import {
  StackLayout as StackLayout19,
  StackItem as StackItem7,
  Card as Card3,
  HeadingText as HeadingText9,
  ParagraphText as ParagraphText9,
  TextAction as TextAction8
} from "@leagueplatform/genesis-core";
import { InternalOrExternalLinkButton } from "@leagueplatform/web-common-components";
function SupportingCard({
  title,
  description,
  routeCopy,
  route,
  onClick
}) {
  return /* @__PURE__ */ React25.createElement(
    Card3.Flat,
    {
      backgroundColor: "primary",
      css: {
        borderWidth: "thin",
        borderStyle: "solid",
        borderColor: "$onSurfaceBorderSubdued"
      }
    },
    /* @__PURE__ */ React25.createElement(Card3.Section, null, /* @__PURE__ */ React25.createElement(StackLayout19, { verticalAlignment: "spaceBetween" }, /* @__PURE__ */ React25.createElement(StackItem7, null, /* @__PURE__ */ React25.createElement(HeadingText9, { level: "3", size: "sm", css: { marginBottom: "$one" } }, title), /* @__PURE__ */ React25.createElement(ParagraphText9, { css: { marginBottom: "$none" } }, description)), /* @__PURE__ */ React25.createElement(StackItem7, null, /* @__PURE__ */ React25.createElement(
      InternalOrExternalLinkButton,
      {
        baseComponent: TextAction8,
        icon: "interfaceChevronForward",
        size: "medium",
        css: {
          display: "flex",
          flexDirection: "row-reverse",
          justifyContent: "flex-end",
          marginTop: "$oneAndHalf"
        },
        href: route,
        onClick
      },
      routeCopy
    ))))
  );
}

// src/components/cost-details/cost-details.component.tsx
import * as React26 from "react";
import { useIntl as useIntl22 } from "@leagueplatform/locales";
import {
  HeadingText as HeadingText10,
  StackLayout as StackLayout20,
  Popover as Popover2,
  UtilityText as UtilityText6,
  styled as styled5,
  Icon as Icon5
} from "@leagueplatform/genesis-core";
import { useFormatClaimsValue as useFormatClaimsValue3 } from "@leagueplatform/claims-common";
import { SHORT_DATE_FORMAT as SHORT_DATE_FORMAT3 } from "@leagueplatform/web-common";
var Indicator = styled5("span", {
  width: 8,
  height: 8,
  borderRadius: "$circle"
});
function isServiceOwed(owed) {
  return (owed == null ? void 0 : owed.total) !== void 0;
}
function CostDetails({
  charged,
  memberDiscount,
  paidDate,
  planPaid,
  owed,
  otherInsurancePaid,
  showCostBreakdown = false,
  showMathLines = true,
  onClick
}) {
  var _a;
  const { formatMessage, formatDate } = useIntl22();
  const formatClaimsValue = useFormatClaimsValue3();
  const owedValue = isServiceOwed(owed) ? owed.total : owed;
  const owedLabel = useClaimOwedAmountLabel({
    owed: owedValue,
    // this section is only rendered for non-pending Claims
    isPending: false
  });
  const hasIndicators = showMathLines && [charged, memberDiscount, planPaid, owed, otherInsurancePaid].some(
    (item) => item == null ? void 0 : item.indicatorColor
  );
  let paymentDate;
  if (paidDate) {
    paymentDate = formatDate(paidDate, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT3), {
      timeZone: "UTC"
    }));
  }
  const labels = [
    formatMessage({ id: "CLAIMS_COST_DETAILS_PROVIDER_CHARGED" }),
    formatMessage({ id: "CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT" }),
    formatMessage({ id: "CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE" }),
    formatMessage({ id: "CLAIMS_COST_DETAILS_WE_PAID_ON" }, { paymentDate })
  ];
  const formattedLines = [charged, memberDiscount, otherInsurancePaid, planPaid].map((line, index) => {
    let amount = line == null ? void 0 : line.amount;
    if (line === otherInsurancePaid && amount === 0) {
      amount = void 0;
    }
    if (showMathLines && index > 0 && amount !== void 0) {
      amount *= -1;
    }
    return __spreadProps(__spreadValues({}, line), {
      label: labels[index],
      amount,
      id: index
    });
  }).filter((line) => line.amount !== void 0);
  return /* @__PURE__ */ React26.createElement(
    StackLayout20,
    {
      as: "ul",
      spacing: "$one",
      "aria-label": formatMessage({
        id: "CLAIMS_SERVICE_DETAILS_SERVICE_COST_DETAILS"
      }),
      horizontalAlignment: "stretch"
    },
    formattedLines.map((line) => /* @__PURE__ */ React26.createElement(
      StackLayout20,
      {
        key: line.id,
        as: "li",
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$half"
      },
      hasIndicators && /* @__PURE__ */ React26.createElement(
        Indicator,
        {
          css: { backgroundColor: line.indicatorColor },
          "data-testid": "indicator"
        }
      ),
      /* @__PURE__ */ React26.createElement(
        StackLayout20,
        {
          orientation: "horizontal",
          verticalAlignment: "center",
          horizontalAlignment: "spaceBetween"
        },
        /* @__PURE__ */ React26.createElement(UtilityText6, { css: { typography: "$bodyTwo" } }, line.label, " ", line.tooltip && /* @__PURE__ */ React26.createElement(Popover2.Root, null, /* @__PURE__ */ React26.createElement(Popover2.Trigger, null, /* @__PURE__ */ React26.createElement(
          "button",
          {
            type: "button",
            "aria-label": line.tooltipLabel,
            style: {
              display: "inline-flex",
              cursor: "pointer",
              background: "transparent",
              border: "none",
              padding: 0,
              margin: 0,
              borderRadius: "50%",
              position: "relative",
              top: 2
            },
            onClick: () => onClick(line.tooltipLabel)
          },
          /* @__PURE__ */ React26.createElement(
            Icon5,
            {
              icon: "statusInformationCircle",
              size: 14,
              tint: "$interactiveActionPrimary"
            }
          )
        )), /* @__PURE__ */ React26.createElement(
          Popover2.Content,
          {
            align: "start",
            alignOffset: -12,
            avoidCollisions: true,
            showCloseButton: false,
            side: "bottom",
            css: {
              width: 320,
              maxWidth: "100vw"
            }
          },
          /* @__PURE__ */ React26.createElement(UtilityText6, null, line.tooltip)
        ))),
        /* @__PURE__ */ React26.createElement(UtilityText6, { css: { typography: "$bodyTwo" } }, formatClaimsValue({
          amount: line.amount,
          currencyCode: line.currencyCode
        }))
      )
    )),
    /* @__PURE__ */ React26.createElement(StackLayout20, { as: "li", horizontalAlignment: "stretch", spacing: "$one" }, /* @__PURE__ */ React26.createElement(
      StackLayout20,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$half",
        css: showMathLines ? {
          borderTop: "1px solid $onSurfaceBorderSubdued",
          paddingTop: "$oneAndHalf",
          marginTop: "$half"
        } : void 0
      },
      hasIndicators && /* @__PURE__ */ React26.createElement(
        Indicator,
        {
          css: { backgroundColor: owed == null ? void 0 : owed.indicatorColor },
          "data-testid": "indicator"
        }
      ),
      /* @__PURE__ */ React26.createElement(
        StackLayout20,
        {
          orientation: "horizontal",
          verticalAlignment: "center",
          horizontalAlignment: "spaceBetween"
        },
        /* @__PURE__ */ React26.createElement(HeadingText10, { size: "md", as: "span", level: "4" }, formatMessage({ id: "CLAIMS_COST_DETAILS_YOUR_COST" }), " "),
        /* @__PURE__ */ React26.createElement(HeadingText10, { size: "md", as: "span", level: "4" }, owedLabel)
      )
    ), showCostBreakdown && isServiceOwed(owed) && ((_a = owed == null ? void 0 : owed.lineItems) == null ? void 0 : _a.length) && /* @__PURE__ */ React26.createElement(MemberCostBreakdown, { costData: owed.lineItems }))
  );
}

// src/components/total-cost-overview/total-cost-overview.component.tsx
import * as React28 from "react";
import { StackLayout as StackLayout21, StackItem as StackItem8 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl24 } from "@leagueplatform/locales";

// src/components/total-cost-overview/hooks/use-graph-colors/use-graph-colors.hook.ts
import { useTheme } from "@leagueplatform/genesis-core";
function useGraphColors() {
  const { colors } = useTheme();
  const DISCOUNT_HEX_VALUE = `${colors.dataVizCategoricalThree}`;
  const PAID_HEX_VALUE = `${colors.dataVizCategoricalFour}`;
  const OWED_HEX_VALUE = `${colors.dataVizCategoricalSix}`;
  const OTHER_HEX_VALUE = `${colors.dataVizCategoricalOne}`;
  return {
    DISCOUNT_HEX_VALUE,
    PAID_HEX_VALUE,
    OWED_HEX_VALUE,
    OTHER_HEX_VALUE
  };
}

// src/components/total-cost-overview/total-cost-pie-graph/total-cost-pie-graph.component.tsx
import * as React27 from "react";
import { useFormatClaimsValue as useFormatClaimsValue4 } from "@leagueplatform/claims-common";
import { useIntl as useIntl23 } from "@leagueplatform/locales";
import Pie from "@visx/shape/lib/shapes/Pie";
import { Group } from "@visx/group";
import { useTheme as useTheme2 } from "@leagueplatform/genesis-core";
import { Text } from "@visx/text";
var width = 200;
var height = 200;
var centerY = height / 2;
var centerX = width / 2;
function FormattedText({ children, offset }) {
  const theme = useTheme2();
  return /* @__PURE__ */ React27.createElement(
    Text,
    {
      textAnchor: "middle",
      x: centerX,
      y: offset,
      dy: ".33em",
      scaleToFit: "shrink-only",
      width: 115,
      style: {
        fontWeight: theme.fontWeights.bodyTwo,
        fontSize: theme.fontSizes.bodyTwo,
        fill: theme.colors.onSurfaceTextSubdued
      }
    },
    children
  );
}
var amountAccessor = (serviceBreakdownItem) => {
  var _a;
  return (_a = serviceBreakdownItem.amount) != null ? _a : 0;
};
var pieSorter = () => 1;
function TotalCostPieGraph({ totals }) {
  var _a, _b, _c, _d;
  const { formatMessage } = useIntl23();
  const formatClaimsValue = useFormatClaimsValue4();
  const {
    DISCOUNT_HEX_VALUE,
    OTHER_HEX_VALUE,
    OWED_HEX_VALUE,
    PAID_HEX_VALUE
  } = useGraphColors();
  const VERTICAL_TEXT_OFFSET = 12;
  const costBreakdown = [
    {
      amount: (_a = totals.memberDiscount) == null ? void 0 : _a.amount,
      color: DISCOUNT_HEX_VALUE
    },
    {
      amount: (_b = totals.otherInsurancePaid) == null ? void 0 : _b.amount,
      color: OTHER_HEX_VALUE
    },
    {
      amount: (_c = totals.planPaid) == null ? void 0 : _c.amount,
      color: PAID_HEX_VALUE
    },
    {
      amount: (_d = totals.owed) == null ? void 0 : _d.amount,
      color: OWED_HEX_VALUE
    }
  ].filter((item) => Boolean(item.amount));
  const radius = Math.min(width, height) / 2;
  const donutThickness = 25;
  return /* @__PURE__ */ React27.createElement(
    "svg",
    {
      width,
      height,
      "data-testid": "total-cost-overview-pie-graph"
    },
    /* @__PURE__ */ React27.createElement(Group, { top: centerY, left: centerX }, /* @__PURE__ */ React27.createElement(
      Pie,
      {
        data: costBreakdown,
        pieValue: amountAccessor,
        pieSort: pieSorter,
        outerRadius: radius,
        innerRadius: radius - donutThickness,
        padAngle: 0.02
      },
      (pie) => pie.arcs.map((arc) => {
        var _a2;
        return /* @__PURE__ */ React27.createElement("g", { key: arc.index }, /* @__PURE__ */ React27.createElement("path", { d: (_a2 = pie.path(arc)) != null ? _a2 : void 0, fill: arc.data.color }));
      })
    )),
    /* @__PURE__ */ React27.createElement(FormattedText, { offset: centerY - VERTICAL_TEXT_OFFSET, "aria-hidden": "true" }, formatMessage({ id: "CLAIMS_COST_DETAILS_PROVIDER_CHARGED" })),
    /* @__PURE__ */ React27.createElement(FormattedText, { offset: centerY + VERTICAL_TEXT_OFFSET, "aria-hidden": "true" }, formatClaimsValue(totals.charged))
  );
}

// src/components/total-cost-overview/total-cost-overview.component.tsx
var TotalCostOverview = ({
  totals,
  paidDate,
  onCostDetailsClick,
  showGraph = true
}) => {
  const { formatMessage } = useIntl24();
  const {
    DISCOUNT_HEX_VALUE,
    OTHER_HEX_VALUE,
    OWED_HEX_VALUE,
    PAID_HEX_VALUE
  } = useGraphColors();
  const totalsOwed = totals.owed ? __spreadProps(__spreadValues({}, totals.owed), {
    indicatorColor: OWED_HEX_VALUE
  }) : void 0;
  const totalsPlanPaid = totals.planPaid ? __spreadProps(__spreadValues({}, totals.planPaid), {
    indicatorColor: PAID_HEX_VALUE,
    tooltip: formatMessage({
      id: "CLAIMS_COST_DETAILS_WE_PAID_ON_TOOLTIP"
    }),
    tooltipLabel: formatMessage({
      id: "CLAIMS_COST_DETAILS_WE_PAID_ON_TOOLTIP_LABEL"
    })
  }) : void 0;
  const totalsDiscounts = totals.memberDiscount ? __spreadProps(__spreadValues({}, totals.memberDiscount), {
    indicatorColor: DISCOUNT_HEX_VALUE,
    tooltip: formatMessage({
      id: "CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT_TOOLTIP"
    }),
    tooltipLabel: formatMessage({
      id: "CLAIMS_COST_DETAILS_YOUR_MEMBER_DISCOUNT_TOOLTIP_LABEL"
    })
  }) : void 0;
  const totalsOtherInsurance = totals.otherInsurancePaid ? __spreadProps(__spreadValues({}, totals.otherInsurancePaid), {
    indicatorColor: OTHER_HEX_VALUE,
    tooltip: formatMessage({
      id: "CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE_TOOLTIP"
    }),
    tooltipLabel: formatMessage({
      id: "CLAIMS_COST_DETAILS_YOUR_OTHER_INSURANCE_TOOLTIP_LABEL"
    })
  }) : void 0;
  return /* @__PURE__ */ React28.createElement(
    StackLayout21,
    {
      spacing: "$oneAndHalf",
      orientation: {
        "@initial": "horizontal",
        "@mobile": "vertical",
        "@mobileLandscape": "vertical"
      },
      horizontalAlignment: "stretch",
      verticalAlignment: "stretch"
    },
    showGraph && /* @__PURE__ */ React28.createElement(
      StackItem8,
      {
        growFactor: 1,
        "aria-hidden": "true",
        horizontalAlignment: "center"
      },
      /* @__PURE__ */ React28.createElement(TotalCostPieGraph, { totals })
    ),
    /* @__PURE__ */ React28.createElement(StackItem8, { growFactor: 4 }, /* @__PURE__ */ React28.createElement(
      CostDetails,
      {
        charged: totals.charged,
        planPaid: totalsPlanPaid,
        owed: totalsOwed,
        memberDiscount: totalsDiscounts,
        otherInsurancePaid: totalsOtherInsurance,
        paidDate,
        onClick: onCostDetailsClick,
        showMathLines: showGraph
      }
    ))
  );
};

// src/components/service-details/service-details.component.tsx
import * as React34 from "react";
import { uniqueId as uniqueId4 } from "lodash";
import {
  Card as Card7,
  Responsive as Responsive2,
  StackLayout as StackLayout23,
  VisuallyHidden,
  styled as styled6
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl28 } from "@leagueplatform/locales";
import { SHORT_DATE_FORMAT as SHORT_DATE_FORMAT5 } from "@leagueplatform/web-common";

// src/utils/format-titlecase.util.ts
var formatTitleCase = (str = "") => str.toLowerCase().split(" ").map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`).join(" ");

// src/components/service-details/components/expandable-content.component.tsx
import * as React30 from "react";
import { Card as Card4 } from "@leagueplatform/genesis-core";

// src/components/service-details/components/service-banner.component.tsx
import * as React29 from "react";
import { ParagraphText as ParagraphText10, StatusBanner } from "@leagueplatform/genesis-core";
import { useIntl as useIntl25 } from "@leagueplatform/locales";
function ServiceBanner({ rejectionDetails }) {
  const { formatMessage } = useIntl25();
  return /* @__PURE__ */ React29.createElement(
    StatusBanner,
    {
      showIcon: true,
      status: "info",
      title: formatMessage({ id: "CLAIMS_SERVICE_DETAILS_SERVICE_REMARK" }),
      css: { boxShadow: "$card" }
    },
    /* @__PURE__ */ React29.createElement(ParagraphText10, { css: { typography: "$bodyTwo" } }, rejectionDetails.description)
  );
}

// src/components/service-details/components/expandable-content.component.tsx
function getIsLowDataState(service) {
  var _a;
  const requiredValues = [
    (_a = service.owed) == null ? void 0 : _a.total,
    service.charged,
    service.memberDiscount,
    service.planPaid,
    service.otherInsurancePaid
  ];
  return requiredValues.some((value) => value === void 0);
}
function ExpandableContent({
  service,
  onCostDetailsClick
}) {
  const isLowDataState = getIsLowDataState(service);
  return /* @__PURE__ */ React30.createElement(React30.Fragment, null, service.rejectionDetails && /* @__PURE__ */ React30.createElement(ServiceBanner, { rejectionDetails: service.rejectionDetails }), /* @__PURE__ */ React30.createElement(
    Card4.Flat,
    {
      backgroundColor: "primary",
      css: {
        border: "1px solid $onSurfaceBorderSubdued",
        padding: "$oneAndHalf",
        "@mobile": { padding: "$one" }
      }
    },
    /* @__PURE__ */ React30.createElement(
      CostDetails,
      {
        charged: service.charged,
        memberDiscount: service.memberDiscount,
        planPaid: service.planPaid,
        owed: service == null ? void 0 : service.owed,
        otherInsurancePaid: service.otherInsurancePaid,
        paidDate: service.paidDate,
        showCostBreakdown: true,
        onClick: onCostDetailsClick,
        showMathLines: !isLowDataState
      }
    )
  ));
}

// src/components/service-details/components/cost-details-toggle-action.component.tsx
import * as React31 from "react";
import { TextAction as TextAction9 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl26 } from "@leagueplatform/locales";
function CostDetailsToggleAction(_a) {
  var _b = _a, {
    open
  } = _b, props = __objRest(_b, [
    "open"
  ]);
  const { $tifelse } = useIntl26();
  const iconName = open ? "interfaceChevronUp" : "interfaceChevronDown";
  const label = $tifelse(
    open,
    "CLAIMS_SERVICE_DETAILS_HIDE_COST_DETAILS",
    "CLAIMS_SERVICE_DETAILS_SHOW_COST_DETAILS"
  );
  return /* @__PURE__ */ React31.createElement(
    TextAction9,
    __spreadValues({
      as: "button",
      icon: iconName,
      size: "medium",
      css: {
        flexDirection: "row-reverse",
        alignSelf: "start",
        "& > svg": {
          width: "12px",
          height: "12px",
          marginInlineStart: "$quarter",
          color: "$onSurfaceIconPrimary"
        }
      }
    }, props),
    label
  );
}

// src/components/service-details/components/mobile-service-details.component.tsx
import * as React33 from "react";
import { Box as Box12, Card as Card6 } from "@leagueplatform/genesis-core";

// src/components/service-details/components/service-details-card.component.tsx
import * as React32 from "react";
import { useIntl as useIntl27 } from "@leagueplatform/locales";
import uniqueId3 from "lodash/uniqueId";
import { Card as Card5, StackLayout as StackLayout22, UtilityText as UtilityText7 } from "@leagueplatform/genesis-core";
import { SHORT_DATE_FORMAT as SHORT_DATE_FORMAT4 } from "@leagueplatform/web-common";
function ServiceDetailsCard({
  service,
  isPending,
  claimType,
  onCostDetailsClick
}) {
  var _a;
  const { formatMessage, formatDate } = useIntl27();
  const [isExpanded, setIsExpanded] = React32.useState(false);
  const headingId = React32.useMemo(
    () => uniqueId3("service-detail-card-heading"),
    []
  );
  const toggleSectionId = React32.useMemo(
    () => uniqueId3("service-detail-card-toggle-section"),
    []
  );
  const toggleButtonId = React32.useMemo(
    () => uniqueId3("service-detail-card-toggle-section"),
    []
  );
  const hasExpandedData = !isPending && Boolean(service.owed);
  const owedLabel = useClaimOwedAmountLabel({
    owed: (_a = service.owed) == null ? void 0 : _a.total,
    isPending
  });
  let codeLabel = formatMessage({
    id: "CLAIMS_SERVICE_DETAILS_SERVICE_PROCEDURE_CODE"
  });
  if (claimType === "pharmacy") {
    codeLabel = formatMessage({
      id: "CLAIMS_SERVICE_DETAILS_SERVICE_RX_NUMBER"
    });
  }
  return /* @__PURE__ */ React32.createElement(Card5.Flat, { css: { padding: "$oneAndHalf" } }, /* @__PURE__ */ React32.createElement(StackLayout22, { horizontalAlignment: "stretch", spacing: "$threeQuarters" }, /* @__PURE__ */ React32.createElement(
    UtilityText7,
    {
      css: { typography: "$caption" },
      "data-testid": "service-date"
    },
    formatDate(service.serviceDate, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT4), {
      timeZone: "UTC"
    }))
  ), /* @__PURE__ */ React32.createElement(UtilityText7, { id: headingId, as: "h3", css: { typography: "$bodyOne" } }, service.name), /* @__PURE__ */ React32.createElement(
    UtilityText7,
    {
      as: "p",
      css: { typography: "$caption" },
      "data-testid": "service-code"
    },
    codeLabel,
    ": ",
    service.code
  ), /* @__PURE__ */ React32.createElement(UtilityText7, { as: "p", css: { typography: "$caption" } }, formatMessage({
    id: "CLAIMS_SERVICE_DETAILS_SERVICE_YOUR_COST"
  }), ":", " ", /* @__PURE__ */ React32.createElement(
    UtilityText7,
    {
      css: { typography: "$headingFour" },
      "data-testid": "service-cost"
    },
    owedLabel
  )), hasExpandedData && /* @__PURE__ */ React32.createElement(React32.Fragment, null, /* @__PURE__ */ React32.createElement(
    CostDetailsToggleAction,
    {
      "aria-controls": toggleSectionId,
      "aria-expanded": isExpanded,
      "aria-labelledby": `${toggleButtonId} ${headingId}`,
      id: toggleButtonId,
      open: isExpanded,
      onClick: () => setIsExpanded(!isExpanded)
    }
  ), /* @__PURE__ */ React32.createElement(
    StackLayout22,
    {
      "data-testid": "expandable-content-wrapper",
      id: toggleSectionId,
      horizontalAlignment: "stretch",
      spacing: "$oneAndHalf",
      css: {
        backgroundColor: "$surfaceBackgroundTertiary",
        padding: "$oneAndHalf",
        marginX: "$minusOneAndHalf",
        marginBottom: "$minusOneAndHalf",
        marginTop: "12px"
      },
      style: {
        display: isExpanded ? "flex" : "none"
      }
    },
    /* @__PURE__ */ React32.createElement(
      ExpandableContent,
      {
        service,
        onCostDetailsClick
      }
    )
  ))));
}

// src/components/service-details/components/mobile-service-details.component.tsx
function MobileServiceDetails({
  services,
  isPending,
  claimType,
  onCostDetailsClick
}) {
  return /* @__PURE__ */ React33.createElement(
    Card6.Flat,
    {
      backgroundColor: "transparent",
      css: {
        border: "$borderWidths$thin solid $onSurfaceBorderSubdued"
      }
    },
    /* @__PURE__ */ React33.createElement(
      Box12,
      {
        as: "ul",
        css: {
          "& > li + li": {
            borderTop: "$borderWidths$thin solid $onSurfaceBorderSubdued"
          }
        }
      },
      services.map((service) => /* @__PURE__ */ React33.createElement("li", { key: service.code }, /* @__PURE__ */ React33.createElement(
        ServiceDetailsCard,
        {
          service,
          isPending,
          claimType,
          onCostDetailsClick
        }
      )))
    )
  );
}

// src/components/service-details/service-details.component.tsx
var Th = styled6("th", {
  backgroundColor: "$surfaceBackgroundTertiary",
  textAlign: "start",
  padding: "$threeQuarters 0",
  typography: "$label",
  color: "$onSurfaceTextSubdued",
  paddingInlineStart: "$one",
  "&:last-child": {
    paddingInlineEnd: "$one"
  }
});
var Td = styled6("td", {
  borderBottom: "1px solid $onSurfaceBorderSubdued",
  padding: "$half 0",
  height: "$four",
  verticalAlign: "middle",
  paddingInlineStart: "$one",
  "tr:last-child &": {
    borderBottom: "none"
  },
  "&:last-child": {
    paddingInlineEnd: "$one"
  }
});
function ToggleableServiceRow({
  service,
  isPending,
  onCostDetailsClick,
  onCostDetailsToggle
}) {
  var _a;
  const { formatDate } = useIntl28();
  const [isExpanded, setIsExpanded] = React34.useState(false);
  const headingId = React34.useMemo(
    () => uniqueId4("service-detail-table-heading"),
    []
  );
  const toggleSectionId = React34.useMemo(
    () => uniqueId4("service-detail-table-toggle-section"),
    []
  );
  const toggleButtonId = React34.useMemo(
    () => uniqueId4("service-detail-table-toggle-section"),
    []
  );
  const owedLabel = useClaimOwedAmountLabel({
    owed: (_a = service.owed) == null ? void 0 : _a.total,
    isPending
  });
  const hasExpandedData = !isPending;
  const formattedServiceName = formatTitleCase(service.name);
  return /* @__PURE__ */ React34.createElement(React34.Fragment, null, /* @__PURE__ */ React34.createElement("tr", null, /* @__PURE__ */ React34.createElement(Td, { "data-testid": "service-date" }, formatDate(service.serviceDate, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT5), {
    timeZone: "UTC"
  }))), /* @__PURE__ */ React34.createElement(Td, { id: headingId }, formattedServiceName), /* @__PURE__ */ React34.createElement(Td, null, service.code), /* @__PURE__ */ React34.createElement(Td, { css: { textAlign: "end" }, "data-testid": "service-cost" }, owedLabel), !isPending && /* @__PURE__ */ React34.createElement(Td, { css: { textAlign: "end" } }, /* @__PURE__ */ React34.createElement(
    CostDetailsToggleAction,
    {
      id: toggleButtonId,
      "aria-labelledby": `${toggleButtonId} ${headingId}`,
      "aria-controls": toggleSectionId,
      "aria-expanded": isExpanded,
      open: isExpanded,
      onClick: () => {
        setIsExpanded(!isExpanded);
        onCostDetailsToggle();
      }
    }
  ))), hasExpandedData && /* @__PURE__ */ React34.createElement(
    "tr",
    {
      id: toggleSectionId,
      style: { display: isExpanded ? void 0 : "none" }
    },
    /* @__PURE__ */ React34.createElement("td", { colSpan: 5 }, /* @__PURE__ */ React34.createElement(
      StackLayout23,
      {
        css: {
          backgroundColor: "$surfaceBackgroundSecondary",
          padding: "$oneAndHalf 20%",
          minWidth: "60%"
        },
        spacing: "$one",
        horizontalAlignment: "stretch"
      },
      /* @__PURE__ */ React34.createElement(
        ExpandableContent,
        {
          service,
          onCostDetailsClick
        }
      )
    ))
  ));
}
function ServiceDetails({
  services,
  "aria-labelledby": ariaLabelledBy,
  "aria-label": ariaLabel,
  isPending,
  claimType,
  onCostDetailsClick,
  onCostDetailsToggle
}) {
  const { formatMessage } = useIntl28();
  let codeLabel = formatMessage({
    id: "CLAIMS_SERVICE_DETAILS_SERVICE_PROCEDURE_CODE"
  });
  let serviceLabel = formatMessage({ id: "CLAIMS_SERVICE_DETAILS_SERVICE" });
  if (claimType === "pharmacy") {
    codeLabel = formatMessage({
      id: "CLAIMS_SERVICE_DETAILS_SERVICE_RX_NUMBER"
    });
    serviceLabel = formatMessage({
      id: "CLAIMS_SERVICE_DETAILS_PHARMACY_SERVICE"
    });
  }
  return /* @__PURE__ */ React34.createElement(React34.Fragment, null, /* @__PURE__ */ React34.createElement(Responsive2, { down: "tablet" }, /* @__PURE__ */ React34.createElement(
    MobileServiceDetails,
    {
      services,
      isPending,
      claimType,
      onCostDetailsClick
    }
  )), /* @__PURE__ */ React34.createElement(Responsive2, { up: "tablet" }, /* @__PURE__ */ React34.createElement(
    Card7.Flat,
    {
      backgroundColor: "primary",
      css: { border: "1px solid $onSurfaceBorderSubdued" }
    },
    /* @__PURE__ */ React34.createElement("table", { "aria-labelledby": ariaLabelledBy, "aria-label": ariaLabel }, /* @__PURE__ */ React34.createElement("thead", null, /* @__PURE__ */ React34.createElement("tr", null, /* @__PURE__ */ React34.createElement(Th, { scope: "col" }, formatMessage({ id: "CLAIMS_SERVICE_DETAILS_DATE" })), /* @__PURE__ */ React34.createElement(Th, { scope: "col", "data-testid": "service-name" }, serviceLabel), /* @__PURE__ */ React34.createElement(Th, { scope: "col", "data-testid": "service-code" }, codeLabel), /* @__PURE__ */ React34.createElement(Th, { scope: "col", css: { textAlign: "end" } }, formatMessage({
      id: "CLAIMS_SERVICE_DETAILS_SERVICE_YOUR_COST"
    })), !isPending && /* @__PURE__ */ React34.createElement(Th, { scope: "col", css: { textAlign: "end", width: "190px" } }, /* @__PURE__ */ React34.createElement(VisuallyHidden, null, formatMessage({
      id: "CLAIMS_SERVICE_DETAILS_SERVICE_COST_DETAILS"
    }))))), /* @__PURE__ */ React34.createElement("tbody", null, services.map((service) => /* @__PURE__ */ React34.createElement(
      ToggleableServiceRow,
      {
        key: service.code,
        service,
        isPending,
        onCostDetailsClick,
        onCostDetailsToggle
      }
    ))))
  )));
}

// src/components/claims-filters/filter-chip/filter-chip.component.tsx
import * as React35 from "react";
import { Button as Button5, VisuallyHidden as VisuallyHidden2 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl29 } from "@leagueplatform/locales";
function FilterChip2({
  label,
  onClick: onClickCallback
}) {
  const { formatMessage } = useIntl29();
  return /* @__PURE__ */ React35.createElement(
    Button5,
    {
      type: "button",
      priority: "secondary",
      icon: "tinyClose",
      onClick: onClickCallback,
      css: {
        display: "inline-flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        typography: "$caption",
        borderRadius: "$large",
        backgroundColor: "$surfaceBackgroundSecondary",
        color: "$onSurfaceTextPrimary",
        borderColor: "$interactiveActionPrimary",
        paddingTop: "$quarter",
        paddingBottom: "$quarter",
        paddingInlineStart: "$none",
        paddingInlineEnd: "$half",
        whiteSpace: "nowrap",
        svg: {
          width: "10px",
          height: "10px",
          color: "$interactiveActionPrimary"
        },
        "& > *": {
          paddingInlineStart: "$half",
          paddingInlineEnd: "$none"
        },
        "&:hover": {
          backgroundColor: "$surfaceBackgroundTertiary",
          borderColor: "$interactiveActionPrimary",
          color: "$onSurfaceTextPrimary"
        }
      }
    },
    /* @__PURE__ */ React35.createElement("span", { "aria-hidden": true }, label),
    /* @__PURE__ */ React35.createElement(VisuallyHidden2, null, formatMessage({ id: "CLAIMS_REMOVE_FILTER" }, { label }))
  );
}

// src/components/claims-filters/filter-chip/filter-chip-layout.component.tsx
import { StackLayout as StackLayout24 } from "@leagueplatform/genesis-core";
import * as React36 from "react";
function FilterChipsLayout({ children }) {
  return /* @__PURE__ */ React36.createElement(
    StackLayout24,
    {
      orientation: "horizontal",
      spacing: "$threeQuarters $one",
      verticalAlignment: "center",
      css: {
        flexWrap: "wrap",
        maxWidth: "100%",
        paddingBottom: "$half",
        paddingTop: "$one",
        "@mobile": {
          flexWrap: "nowrap",
          overflowX: "auto"
        }
      }
    },
    children
  );
}

// src/components/claims-skeleton-loader-list/claims-skeleton-loader-list.component.tsx
import * as React37 from "react";
import {
  SkeletonRectangle,
  VisuallyHidden as VisuallyHidden3,
  StackLayout as StackLayout25
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl30 } from "@leagueplatform/locales";
function ClaimsSkeletonLoaderList({
  numberOfLoaders = 10
}) {
  const { formatMessage } = useIntl30();
  const loadersArray = React37.useMemo(
    () => Array.from(Array(numberOfLoaders).keys()),
    [numberOfLoaders]
  );
  return /* @__PURE__ */ React37.createElement(StackLayout25, { spacing: "$oneAndHalf", css: { maxWidth: "100%" } }, loadersArray.map((num) => /* @__PURE__ */ React37.createElement(
    SkeletonRectangle,
    {
      key: `card-loader-${num}`,
      height: 140,
      width: "100%"
    }
  )), /* @__PURE__ */ React37.createElement(VisuallyHidden3, null, formatMessage({ id: "LOADING" })));
}

// src/utils/get-filter-input-component.util.ts
var getFilterInputComponent = (filterType) => {
  switch (filterType) {
    case "radio": {
      return RadioFilterInput;
    }
    case "checkbox": {
      return CheckboxFilterInput;
    }
    case "free_form": {
      return null;
    }
    default: {
      return null;
    }
  }
};

// src/mocks/claims-filter.mock.ts
var mockClaimCheckboxInputFilter = {
  label: "Claim Status",
  name: "claim_status",
  options: [
    {
      label: "Processing",
      value: "processing",
      id: "processing-claim-status"
    },
    {
      label: "We'll Pay Our Part",
      value: "paid",
      id: "paid-claim-status"
    },
    {
      label: "Partially Covered",
      value: "partially_covered",
      id: "partially-covered-claim-status"
    }
  ]
};
var mockClaimRadioInputFilter = {
  label: "Date Range",
  name: "date_range",
  options: [
    {
      label: "Last 12 Months",
      value: "2023-01-09T05:00:00Z/2024-01-09T20:48:22Z",
      id: "last-12-months-date-range"
    },
    {
      label: "Year to Date",
      value: "2024-01-01T05:00:00Z/2024-01-09T20:48:22Z",
      id: "year-to-date-date-range"
    }
  ]
};

// src/index.ts
initModule();
initMasonryRegistry();
export {
  CheckboxFilterInput,
  ClaimCard,
  ClaimStatusPreview,
  ClaimUserCostCard,
  ClaimsBackButton2 as ClaimsBackButton,
  ClaimsCardList,
  ClaimsErrorState,
  ClaimsHelpfulLinks,
  ClaimsListFilters,
  ClaimsSkeletonLoaderList,
  ClaimsStatusDefinition,
  ClaimsSummaryCardList,
  ClaimsSummaryLayout,
  ClaimsSummarySidebar,
  ClaimsSummarySidebarMobile,
  CostDetails,
  EobTextAction,
  FilterChip2 as FilterChip,
  FilterChipsLayout,
  FilterDropdown,
  HowClaimsWorkModalTrigger,
  MemberCostBreakdown,
  NetworkCoverageStatus,
  RadioFilterInput,
  ServiceDetails,
  SupportingCard,
  TotalCostOverview,
  getClaimTypeIcon,
  getFilterInputComponent,
  mockClaimCheckboxInputFilter,
  mockClaimRadioInputFilter
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/claims-ui'] = window.leagueSDKsPresent['@leagueplatform/claims-ui'] || [];
    window.leagueSDKsPresent['@leagueplatform/claims-ui'].push('2.22.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/claims-ui'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/claims-ui module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map